
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire985d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire985d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("e59Pk", function(module, exports) {
"use strict";
var $a40927becc846f08$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $04yvT = parcelRequire("04yvT");

var $b3tjO = parcelRequire("b3tjO");

var $h0bLR = parcelRequire("h0bLR");

var $3oIXy = parcelRequire("3oIXy");

var $5TbFc = parcelRequire("5TbFc");

var $8LC4i = parcelRequire("8LC4i");

var $jXOgk = parcelRequire("jXOgk");

const $a40927becc846f08$var$ngramtree_class_1 = $a40927becc846f08$var$__importDefault((parcelRequire("4HGad")));
/**
 * @description User friendly name for the size of the ngram
 * @enum {number}
 */ // I have no idea where eslint thinks this should go. This is literally just to be user friendly; code ain't affected
// eslint-disable-next-line no-shadow
var $a40927becc846f08$var$NGramType;
(function(NGramType) {
    NGramType[NGramType["letter"] = 1] = "letter";
    NGramType[NGramType["bigram"] = 2] = "bigram";
    NGramType[NGramType["trigram"] = 3] = "trigram";
    NGramType[NGramType["word"] = Infinity] = "word";
})($a40927becc846f08$var$NGramType || ($a40927becc846f08$var$NGramType = {}));
class $a40927becc846f08$var$Methodius {
    constructor(text){
        this.text = text;
    }
    /**
     * @description lowercased text with diacritics removed
     * @returns  {string} sanitizedText - text that is all lowercase and without Hebrew diacritics
     */ get sanitizedText() {
        return $a40927becc846f08$var$Methodius.sanitizeText(this.text);
    }
    /**
     * @description an array of letters in the text
     * @returns {NGramSequence} - array of letters in text
     */ get letters() {
        return $a40927becc846f08$var$Methodius.getNGrams(this.sanitizedText, 1);
    }
    /**
     * @description an array of words in the text
     * @returns {Word} - array of words in text
     */ get words() {
        return $a40927becc846f08$var$Methodius.getWords(this.sanitizedText);
    }
    /**
     * @description The average size of a word
     * @returns {number} float or int
     */ get meanWordSize() {
        return $a40927becc846f08$var$Methodius.getMeanWordSize(this.words);
    }
    /**
     * @description The middle size of a word
     * @returns {number} float or int
     */ get medianWordSize() {
        return $a40927becc846f08$var$Methodius.getMedianWordSize(this.words);
    }
    /**
     * @description an array of letter bigrams in the text
     * @returns {NGramSequence} - array of bigrams in text
     */ get bigrams() {
        return $a40927becc846f08$var$Methodius.getNGrams(this.sanitizedText, 2);
    }
    /**
     * @description an array of letter trigrams in the text
     * @returns {NGramSequence} - array of trigrams in text
     */ get trigrams() {
        return $a40927becc846f08$var$Methodius.getNGrams(this.sanitizedText, 3);
    }
    /**
     * @description an array of unique letters in the text
     * @returns {string[]} - array of unique letters in text
     */ get uniqueLetters() {
        return [
            ...new Set(this.letters)
        ];
    }
    /**
     * @description an array of unique bigrams in the text
     * @returns {string[]} - array of unique bigrams in text
     */ get uniqueBigrams() {
        return [
            ...new Set(this.bigrams)
        ];
    }
    /**
     * @description an array of unique trigrams in the text
     * @returns {string[]} - array of unique trigrams in text
     */ get uniqueTrigrams() {
        return [
            ...new Set(this.trigrams)
        ];
    }
    /**
     * @description an array of unique words in the text
     * @returns {Word[]} - array of unique words in text
     */ get uniqueWords() {
        return [
            ...new Set(this.words)
        ];
    }
    /**
     * @description a map of letter frequencies in the sanitized text
     * @returns {FrequencyMap} - map of unique letters in text
     */ get letterFrequencies() {
        return $a40927becc846f08$var$Methodius.getFrequencyMap(this.letters);
    }
    /**
     * @description a map of bigram frequencies in the sanitized text
     * @returns {FrequencyMap} - map of bigram frequencies in text
     */ get bigramFrequencies() {
        return $a40927becc846f08$var$Methodius.getFrequencyMap(this.bigrams);
    }
    /**
     * @description a map of trigram frequencies in the sanitized text
     * @returns {FrequencyMap} - map of trigram frequencies in text
     */ get trigramFrequencies() {
        return $a40927becc846f08$var$Methodius.getFrequencyMap(this.trigrams);
    }
    /**
     * @description a map of word frequencies in the sanitized text
     * @returns {FrequencyMap} - map of unique words in text
     */ get wordFrequencies() {
        return $a40927becc846f08$var$Methodius.getFrequencyMap(this.words);
    }
    /**
     * @description a map of letter percentages in the sanitized text
     * @returns {FrequencyMap} - Map of letter frequencies as percentage in text
     */ get letterPercentages() {
        return $a40927becc846f08$var$Methodius.getPercentMap(this.letterFrequencies);
    }
    /**
     * @description a map of bigram frequencies as percentage in the sanitized text
     * @returns {FrequencyMap} - Map of bigram frequencies as percentage in text
     */ get bigramPercentages() {
        return $a40927becc846f08$var$Methodius.getPercentMap(this.bigramFrequencies);
    }
    /**
     * @description a map of the most used trigrams in the text, as a percent
     * @returns {FrequencyMap} - Map of trigram frequencies as percentage in text
     */ get trigramPercentages() {
        return $a40927becc846f08$var$Methodius.getPercentMap(this.trigramFrequencies);
    }
    /**
     * @description a map of placements of letters within words
     * @returns {PlacementsMap} - Map of letter placements in words
     */ get letterPositions() {
        return $a40927becc846f08$var$Methodius.getWordPlacementForNGrams(this.uniqueLetters, this.words);
    }
    /**
     * @description a map of placements of bigrams within words
     * @returns {PlacementsMap} - Map of letter placements in words
     */ get bigramPositions() {
        return $a40927becc846f08$var$Methodius.getWordPlacementForNGrams(this.uniqueBigrams, this.words);
    }
    /**
     * @description a map of placements of trigrams within words
     * @returns {PlacementsMap} - Map of letter placements in words
     */ get trigramPositions() {
        return $a40927becc846f08$var$Methodius.getWordPlacementForNGrams(this.uniqueTrigrams, this.words);
    }
    /**
     * @description a nested map of maps that breaks down unique words into their smallest ngrams
     * @returns {NGramTreeCollection} - A nested map of words and their ngram trees
     */ get ngramTreeCollection() {
        return $a40927becc846f08$var$Methodius.getNgramTreeCollection(this.uniqueWords);
    }
    /**
     * @description gets an array of customizeable ngrams in the text
     * @param {number} [size=2] - size of nGram
     * @returns {NGramSequence} - array of granms in text
     */ getLetterNGrams(size = 2) {
        return $a40927becc846f08$var$Methodius.getNGrams(this.sanitizedText, size);
    }
    /**
     * @description a map of the most used letters in the text
     * @param {number} [limit=20] - number of top letters to return
     * @returns {FrequencyMap} - map of letters and their frequencies
     */ getTopLetters(limit = 10) {
        return $a40927becc846f08$var$Methodius.getTopGrams(this.letterFrequencies, limit);
    }
    /**
     * @description a map of the most used bigrams in the text
     * @param {number} [limit=20] - number of top bigrams to return
     * @returns {FrequencyMap} - map of bigrams and their frequencies
     */ getTopBigrams(limit = 20) {
        return $a40927becc846f08$var$Methodius.getTopGrams(this.bigramFrequencies, limit);
    }
    /**
     * @description a map of the most used trigrams in the text
     * @param {number} [limit=20] - number of top trigrams to return
     * @returns {FrequencyMap} - map of trigrams and their frequencies
     */ getTopTrigrams(limit = 20) {
        return $a40927becc846f08$var$Methodius.getTopGrams(this.trigramFrequencies, limit);
    }
    /**
     * @description a wrapper for the getTop<whatever>grams methods that gives a choice for the size of ngram to return
     * @param {number} [ngramSize = 2] - the size of the ngram (1 = letter, 2 = bigram, 3 = trigram, 3+ = ngram)
     * @param {number }[limit=20] - number of top ngrams to return
     * @returns {FrequencyMap} - a map of the ngrams and their frequencies
     */ getTopNgrams(ngramSize = 2, limit = 20) {
        let topNgrams;
        switch(ngramSize){
            case 1:
                topNgrams = this.getTopLetters(limit);
                break;
            case 2:
                topNgrams = this.getTopBigrams(limit);
                break;
            case 3:
                topNgrams = this.getTopTrigrams(limit);
                break;
            default:
                {
                    const ngrams = $a40927becc846f08$var$Methodius.getNGrams(this.sanitizedText, ngramSize);
                    const ngramFrequencies = $a40927becc846f08$var$Methodius.getFrequencyMap(ngrams);
                    topNgrams = $a40927becc846f08$var$Methodius.getTopGrams(ngramFrequencies, limit);
                    break;
                }
        }
        return topNgrams;
    }
    /**
     * @description a map of the most used words in the text
     * @param {number} [limit=20] - number of top trigrams to return
     * @returns {FrequencyMap} - map of trigrams and their frequencies
     */ getTopWords(limit = 20) {
        return $a40927becc846f08$var$Methodius.getTopGrams(this.wordFrequencies, limit);
    }
    /**
     * @description evaluates the top ngrams to discover the words which contain them
     * @param  {number} [ngramSize=2] - the size of the ngram
     * @param  {number} [limit=20] - the maximum number of top ngrams
     * @returns {Map<Word, NGram[]>} - a map of words and the ngrams they contain
     */ getWordsContainingTopNgrams(ngramSize = 2, limit = 20) {
        const topNgrams = this.getTopNgrams(ngramSize, limit);
        const topNgramKeys = [
            ...topNgrams.keys()
        ];
        const { ngramTreeCollection: ngramTreeCollection } = this;
        const wordsWithTopNgrams = new Map();
        ngramTreeCollection.forEach((ngramTree, word)=>{
            if (ngramTree instanceof $a40927becc846f08$var$ngramtree_class_1.default) {
                // it's an ngram tree
                const containsTopNgrams = ngramTree.hasAny(topNgramKeys);
                if (containsTopNgrams) {
                    const whichTopNgrams = ngramTree.hasWhich(topNgramKeys);
                    wordsWithTopNgrams.set(word, whichTopNgrams);
                }
            } else {
                // this is an array
                const containsTopNgrams = ngramTree.some((ngram)=>topNgramKeys.includes(ngram));
                if (containsTopNgrams) {
                    const whichTopNgrams = ngramTree.filter((ngram)=>topNgramKeys.includes(ngram));
                    wordsWithTopNgrams.set(word, whichTopNgrams);
                }
            }
        });
        return wordsWithTopNgrams;
    }
    /**
     * @description Gets the ngrams that will occur before or after other ngrams based on what the most frequent ngrams are. Useful for finding patterns of ngrams.
     * @param  {number} [ngramSize = 2] the size of the ngram
     * @param  {number} [limit = 20] number of top ngrams to use as a basis for determining related ngrams
     * @returns {FrequencyMap} A frequency map of how often the most common ngrams occured before or after other common ngrams
     */ getRelatedTopNgrams(ngramSize = 2, limit = 20) {
        // first, let's find the most common ngrams
        const topNgrams = this.getTopNgrams(ngramSize, limit);
        // next, get the words that have them
        const { words: words } = this;
        const relatedNgrams = $a40927becc846f08$var$Methodius.getRelatedNgrams(words, topNgrams, ngramSize);
        return relatedNgrams;
    }
    /**
     * @description Compare this methodius instance's letter, bigrams, trigrams, and words to another methodius instance
     * @param  {Methodius} methodius another methodius instance
     * @returns {Map<NGramType, SequenceComparison>} -A map of property names and their comparisons (intersection, disjunctiveUnions, etc) for a set of properties
     */ compareTo(methodius) {
        if (!(methodius instanceof $a40927becc846f08$var$Methodius)) throw new Error('This must be an instance of Methodius');
        const comparison = new Map();
        comparison.set('letters', $a40927becc846f08$var$Methodius.getComparison(this.letters, methodius.letters));
        comparison.set('bigrams', $a40927becc846f08$var$Methodius.getComparison(this.bigrams, methodius.bigrams));
        comparison.set('trigrams', $a40927becc846f08$var$Methodius.getComparison(this.trigrams, methodius.trigrams));
        comparison.set('words', $a40927becc846f08$var$Methodius.getComparison(this.words, methodius.words));
        return comparison;
    }
}
$a40927becc846f08$var$Methodius.punctuations = $04yvT.punctuations;
$a40927becc846f08$var$Methodius.wordSeparators = $04yvT.wordSeparators;
$a40927becc846f08$var$Methodius.hasPunctuation = $b3tjO.hasPunctuation;
$a40927becc846f08$var$Methodius.hasSymbols = $b3tjO.hasSymbols;
$a40927becc846f08$var$Methodius.hasSpace = $b3tjO.hasSpace;
$a40927becc846f08$var$Methodius.sanitizeText = $b3tjO.sanitizeText;
$a40927becc846f08$var$Methodius.getWords = $b3tjO.getWords;
$a40927becc846f08$var$Methodius.getMeanWordSize = $h0bLR.getMeanWordSize;
$a40927becc846f08$var$Methodius.getMedianWordSize = $h0bLR.getMedianWordSize;
$a40927becc846f08$var$Methodius.getNGrams = $3oIXy.getNGrams;
$a40927becc846f08$var$Methodius.getWordNGrams = $3oIXy.getWordNGrams;
$a40927becc846f08$var$Methodius.getFrequencyMap = $5TbFc.getFrequencyMap;
$a40927becc846f08$var$Methodius.getPercentMap = $5TbFc.getPercentMap;
$a40927becc846f08$var$Methodius.getTopGrams = $5TbFc.getTopGrams;
$a40927becc846f08$var$Methodius.getIntersection = $8LC4i.getIntersection;
$a40927becc846f08$var$Methodius.getUnion = $8LC4i.getUnion;
$a40927becc846f08$var$Methodius.getDisjunctiveUnion = $8LC4i.getDisjunctiveUnion;
$a40927becc846f08$var$Methodius.getComparison = $8LC4i.getComparison;
$a40927becc846f08$var$Methodius.getWordPlacementForNGram = $jXOgk.getWordPlacementForNGram;
$a40927becc846f08$var$Methodius.getWordPlacementForNGrams = $jXOgk.getWordPlacementForNGrams;
$a40927becc846f08$var$Methodius.getNgramCollections = $jXOgk.getNgramCollections;
$a40927becc846f08$var$Methodius.getNgramSiblings = $jXOgk.getNgramSiblings;
$a40927becc846f08$var$Methodius.getNgramTreeCollection = $jXOgk.getNgramTreeCollection;
$a40927becc846f08$var$Methodius.getRelatedNgrams = $jXOgk.getRelatedNgrams;
module.exports.default = $a40927becc846f08$var$Methodius;

});
parcelRegister("04yvT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.symbols = module.exports.wordSeparators = module.exports.punctuations = void 0;
/** a string that can be used by a RegExp to identify start and ends of sentences */ const $00db2578aaa1c789$var$punctuations = "\\.,;:!?\u203D\xa1\xbf\u2E18()\\[\\]{}<>\u2019'\xab\xbb\u2026\u2018\u201C\u201D\"\n	\r";
module.exports.punctuations = $00db2578aaa1c789$var$punctuations;
/** a string that can be used by a RegExp to identify anything that looks like a symbol. */ /* eslint-disable-next-line quotes,max-len */ const $00db2578aaa1c789$var$symbols = "\\$\\^!-#%-*,-/:;?@\\[-\\]_\\{\\}\\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E42\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65";
module.exports.symbols = $00db2578aaa1c789$var$symbols;
/** a string that can be used by a RegExp to identify symbols that can separate words */ const $00db2578aaa1c789$var$wordSeparators = '\u2014\\.,;:!?\u203D\xa1\xbf\u2E18()\\[\\]{}<>\xab\xbb\u2026\u2018\u201C\u201D"\\s';
module.exports.wordSeparators = $00db2578aaa1c789$var$wordSeparators;

});

parcelRegister("b3tjO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWords = module.exports.sanitizeText = module.exports.hasSpace = module.exports.hasSymbols = module.exports.hasPunctuation = void 0;

var $04yvT = parcelRequire("04yvT");
/**
 * @description determines if string contains punctuation
 * @param  {string} text - string to check for punctuation
 * @returns {boolean} - true if string contains punctuation
 */ function $80c6b79030b1c1a4$var$hasPunctuation(text) {
    const punctuationRegEx = new RegExp(`([${$04yvT.punctuations}])`, 'g');
    return punctuationRegEx.test(text);
}
module.exports.hasPunctuation = $80c6b79030b1c1a4$var$hasPunctuation;
/**
 * @description determines if a string contains symbols such as #, $ or ^
 * @param  {string} text - string to check for symbols
 * @returns {boolean} - true if string contains symbols
 */ function $80c6b79030b1c1a4$var$hasSymbols(text) {
    const symbolRegEx = new RegExp(`([${$04yvT.symbols}])`, 'g');
    return symbolRegEx.test(text);
}
module.exports.hasSymbols = $80c6b79030b1c1a4$var$hasSymbols;
/**
 * @description determines if a string has a space
 * @param  {string} text - string to check for space
 * @returns  {boolean} - true if string contains space
 */ function $80c6b79030b1c1a4$var$hasSpace(text) {
    return text.search(/\s/) !== -1;
}
module.exports.hasSpace = $80c6b79030b1c1a4$var$hasSpace;
/**
 * @description lowercases text and removes diacritics and other characters that would throw off n-gram analysis
 * @param  {string} text - string to sanitize
 * @returns {string} - string that is all lowercase and without Hebrew diacritics
 */ function $80c6b79030b1c1a4$var$sanitizeText(text) {
    const stringWithoutDiacritics = text.replace(/\u05BE/g, '-').replace(/[\u0591-\u05C7]/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return stringWithoutDiacritics.toLowerCase();
}
module.exports.sanitizeText = $80c6b79030b1c1a4$var$sanitizeText;
/**
 * @description extracts an array of words from a string
 * @param {string} text - text to be analyzed
 * @returns {Word[]} - array of words in text
 */ function $80c6b79030b1c1a4$var$getWords(text) {
    const wordSeparatorRegex = new RegExp(`[(${$04yvT.wordSeparators})]`, 'g');
    const wordArray = text.split(wordSeparatorRegex).map((word)=>word.trim()).filter((word)=>word.length > 0);
    return wordArray;
}
module.exports.getWords = $80c6b79030b1c1a4$var$getWords;

});

parcelRegister("h0bLR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMedianWordSize = module.exports.getMeanWordSize = void 0;
/**
 * @description Gets average size of a word
 * @param {Word[]} wordArray - text to be analyzed
 * @returns {number} - float. Average size of word
 */ function $c60b913d42d8f9c0$var$getMeanWordSize(wordArray) {
    const filteredArray = wordArray.filter((word)=>word.length > 0);
    const wordSizes = filteredArray.map((word)=>word.trim().length);
    const sum = wordSizes.reduce((accumulator, currentVal)=>accumulator + currentVal, 0);
    const mean = sum / wordSizes.length;
    return mean;
}
module.exports.getMeanWordSize = $c60b913d42d8f9c0$var$getMeanWordSize;
/**
 * @description Gets median size of a word
 * @param {Word[]} wordArray - text to be analyzed
 * @returns {number} - float. the median word size
 */ function $c60b913d42d8f9c0$var$getMedianWordSize(wordArray) {
    const filteredArray = wordArray.filter((word)=>word.length > 0);
    const wordSizes = filteredArray.map((word)=>word.trim().length);
    const sortedSizes = wordSizes.sort((first, second)=>{
        if (first < second) return -1;
        if (second > first) return 1;
        return 0;
    });
    const isOdd = sortedSizes.length % 2 !== 0;
    const median = isOdd ? sortedSizes[Math.floor(sortedSizes.length / 2)] : (sortedSizes[sortedSizes.length / 2] + sortedSizes[sortedSizes.length / 2 + 1]) / 2;
    return median;
}
module.exports.getMedianWordSize = $c60b913d42d8f9c0$var$getMedianWordSize;

});

parcelRegister("3oIXy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWordNGrams = module.exports.getNGrams = void 0;

var $b3tjO = parcelRequire("b3tjO");
/**
 * @description gets ngrams from text
 * @param  {string} text - text to be analyzed
 * @param  {number} [gramSize=2] - size of ngram to be analyzed
 * @returns {NGramSequence} - array of ngrams extracted from a single word
 */ function $27967d069126ade3$var$getNGrams(text, gramSize = 2) {
    const bigrams = [];
    for(let i = 0; i < text.length - (gramSize - 1); i += 1){
        const substring = text.substring(i, i + gramSize);
        if (!(0, $b3tjO.hasPunctuation)(substring) && !(0, $b3tjO.hasSpace)(substring) && !(0, $b3tjO.hasSymbols)(substring)) bigrams.push(substring);
    }
    return bigrams;
}
module.exports.getNGrams = $27967d069126ade3$var$getNGrams;
/**
 * @param {string} text - text to be analyzed
 * @param {number} [gramSize=2] - size of ngram to be analyzed
 * @returns {WordNGram[Word]} - array of words
 * @description - This doesn't use sentence punctuation as a boundary. Should it?
 * @example
 *   getWordNGrams("Hello world. how are you?", 3) would return [[hello, world, how], [world, how, are], [how, are, you]]
 */ function $27967d069126ade3$var$getWordNGrams(text, gramSize = 2) {
    const words = (0, $b3tjO.getWords)(text);
    const wordNGrams = [];
    for(let i = 0; i < words.length - (gramSize - 1); i += 1){
        const substring = words.slice(i, i + gramSize);
        wordNGrams.push(substring);
    }
    return wordNGrams;
}
module.exports.getWordNGrams = $27967d069126ade3$var$getWordNGrams;

});

parcelRegister("5TbFc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTopGrams = module.exports.getPercentMap = module.exports.getFrequencyMap = void 0;
/**
 * @description converts an array of strings into a map of those strings and number of occurences
 * @param  {NGram[]} ngramArray - array of ngrams
 * @returns {FrequencyMap} - map of ngrams and their frequencies
 */ function $449b22e932476a03$var$getFrequencyMap(ngramArray) {
    const frequencies = new Map();
    ngramArray.forEach((ngram)=>{
        if (frequencies.has(ngram)) frequencies.set(ngram, frequencies.get(ngram) + 1);
        else frequencies.set(ngram, 1);
    });
    return frequencies;
}
module.exports.getFrequencyMap = $449b22e932476a03$var$getFrequencyMap;
/**
 * @description converts a frequency map into a map of percentages
 * @param  {FrequencyMap} frequencyMap - map of ngrams and their frequencies
 * @returns {Map<string, number>} - map of ngrams and their percentages
 */ function $449b22e932476a03$var$getPercentMap(frequencyMap) {
    const percentMap = new Map();
    frequencyMap.forEach((value, key)=>{
        percentMap.set(key, value / frequencyMap.size);
    });
    return percentMap;
}
module.exports.getPercentMap = $449b22e932476a03$var$getPercentMap;
/**
 * @description filters a frequency map into only a small subset of the most frequent ones
 * @param  {FrequencyMap} frequencyMap - map of ngrams and their frequencies
 * @param  {number} [limit=20] - number of top ngrams to return
 * @returns {FrequencyMap} - map of ngrams and their frequencies
 */ function $449b22e932476a03$var$getTopGrams(frequencyMap, limit = 20) {
    const orderedGrams = [
        ...frequencyMap
    ].sort((entry1, entry2)=>entry2[1] - entry1[1]);
    const topGrams = orderedGrams.slice(0, limit);
    return new Map(topGrams);
}
module.exports.getTopGrams = $449b22e932476a03$var$getTopGrams;

});

parcelRegister("8LC4i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getComparison = module.exports.getDisjunctiveUnion = module.exports.getUnion = module.exports.getIntersection = void 0;
/**
 * @description returns an array of items that occur in both iterables
 * @param  {Map|Array} iterable1 A map or array
 * @param  {Map|Array} iterable2 A map or array
 * @returns {Intersection} An array of items that occur in both iterables. It will compare the keys, if sent a map
 */ function $66203e0ff5b89319$var$getIntersection(iterable1, iterable2) {
    const array1 = Array.isArray(iterable1) ? iterable1 : [
        ...iterable1.keys()
    ];
    const array2 = Array.isArray(iterable2) ? iterable2 : [
        ...iterable2.keys()
    ];
    const intersection = [];
    array1.forEach((entry)=>{
        if (array2.includes(entry) && !intersection.includes(entry)) intersection.push(entry);
    });
    return intersection;
}
module.exports.getIntersection = $66203e0ff5b89319$var$getIntersection;
/**
 * @description returns an array that is the union of two iterables
 * @param  {Map|Array} iterable1 A map or array
 * @param  {Map|Array} iterable2 A map or array
 * @returns {Union} An array of items. It will  be the keys if sent a map
 */ function $66203e0ff5b89319$var$getUnion(iterable1, iterable2) {
    const array1 = Array.isArray(iterable1) ? iterable1 : [
        ...iterable1.keys()
    ];
    const array2 = Array.isArray(iterable2) ? iterable2 : [
        ...iterable2.keys()
    ];
    const set = new Set();
    array1.forEach((char)=>set.add(char));
    array2.forEach((char)=>set.add(char));
    return [
        ...set
    ];
}
module.exports.getUnion = $66203e0ff5b89319$var$getUnion;
/**
 * @description returns an array of arrays of the unique items in either iterable
 * @param  {Map|Array} iterable1 A map or array
 * @param  {Map|Array} iterable2 A map or array
 * @returns {DisjunctiveUnion} An array of arrays of the unique items. The first item is the first parameter, 2nd item second param
 */ function $66203e0ff5b89319$var$getDisjunctiveUnion(iterable1, iterable2) {
    const array1 = Array.isArray(iterable1) ? iterable1 : [
        ...iterable1.keys()
    ];
    const array2 = Array.isArray(iterable2) ? iterable2 : [
        ...iterable2.keys()
    ];
    const intersection = $66203e0ff5b89319$var$getIntersection(array1, array2);
    const set1 = array1.filter((entry)=>!intersection.includes(entry));
    const set2 = array2.filter((entry)=>!intersection.includes(entry));
    return [
        set1,
        set2
    ];
}
module.exports.getDisjunctiveUnion = $66203e0ff5b89319$var$getDisjunctiveUnion;
/**
 * @description returns a map containing various comparisons between two iterables
 * @param  {Map|NGramSequence} iterable1 an array or map
 * @param  {Map|NGramSequence} iterable2 an array or map
 * @returns {SequenceComparison} A map containing various comparisons between two iterables
 */ function $66203e0ff5b89319$var$getComparison(iterable1, iterable2) {
    const comparison = new Map();
    comparison.set('intersection', $66203e0ff5b89319$var$getIntersection(iterable1, iterable2));
    comparison.set('disjunctiveUnion', $66203e0ff5b89319$var$getDisjunctiveUnion(iterable1, iterable2));
    return comparison;
}
module.exports.getComparison = $66203e0ff5b89319$var$getComparison;

});

parcelRegister("jXOgk", function(module, exports) {
"use strict";
var $e88a8410e9f2a944$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRelatedNgrams = module.exports.getNgramTreeCollection = module.exports.getNgramTree = module.exports.getNgramSiblings = module.exports.getNgramCollections = module.exports.getWordPlacementForNGrams = module.exports.getWordPlacementForNGram = void 0;

var $3oIXy = parcelRequire("3oIXy");

const $e88a8410e9f2a944$var$ngramtree_class_1 = $e88a8410e9f2a944$var$__importDefault((parcelRequire("4HGad")));
/**
 * @description determines the placement of a single ngram in an array of words
 * @param  {NGram} ngram - a unigram, bigram, trigram, or ngram
 * @param  {Word[]} wordsArray - an array of words
 * @returns {PlacementMap} - a map with the keys 'start', 'middle', and 'end'
 */ function $e88a8410e9f2a944$var$getWordPlacementForNGram(ngram, wordsArray) {
    const placementMap = new Map([
        [
            'start',
            0
        ],
        [
            'middle',
            0
        ],
        [
            'end',
            0
        ]
    ]);
    wordsArray.forEach((word)=>{
        const wordNgrams = [
            ...word.matchAll(new RegExp(ngram, 'gi'))
        ];
        if (wordNgrams.length > 0) wordNgrams.forEach((wordNgram)=>{
            const ngramIndex = wordNgram.index;
            switch(ngramIndex){
                case 0:
                    {
                        const start = placementMap.get('start') || 0;
                        placementMap.set('start', start + 1);
                        break;
                    }
                case word.length - ngram.length:
                    {
                        const end = placementMap.get('end') || 0;
                        placementMap.set('end', end + 1);
                        break;
                    }
                default:
                    {
                        const middle = placementMap.get('middle') || 0;
                        placementMap.set('middle', middle + 1);
                        break;
                    }
            }
        });
    });
    return placementMap;
}
module.exports.getWordPlacementForNGram = $e88a8410e9f2a944$var$getWordPlacementForNGram;
/**
 * @description determines the placement of ngrams in an array of words
 * @param  {NGram[]} ngrams - an array of ngrams
 * @param  {Word[]} wordsArray - an array of words
 * @returns {PlacementsMap} - a map with the key of the ngram, and the value that is a map containing start, middle, end
 */ function $e88a8410e9f2a944$var$getWordPlacementForNGrams(ngrams, wordsArray) {
    const wordPlacements = new Map();
    const uniqueNgrams = [
        ...new Set(ngrams)
    ];
    uniqueNgrams.forEach((ngram)=>{
        wordPlacements.set(ngram, $e88a8410e9f2a944$var$getWordPlacementForNGram(ngram, wordsArray));
    });
    return wordPlacements;
}
module.exports.getWordPlacementForNGrams = $e88a8410e9f2a944$var$getWordPlacementForNGrams;
/**
 * @description gets ngrams from an array of words
 * @param {Word[]} wordArray - an array of words
 * @param {number} [ngramSize=2] - the size of the ngrams to return
 * @returns {NGramCollection} - An array of NGramSequences extracted from an array of words
 */ function $e88a8410e9f2a944$var$getNgramCollections(wordArray, ngramSize = 2) {
    const ngramCollections = [];
    wordArray.forEach((word)=>{
        ngramCollections.push((0, $3oIXy.getNGrams)(word, ngramSize));
    });
    return ngramCollections;
}
module.exports.getNgramCollections = $e88a8410e9f2a944$var$getNgramCollections;
/**
 * @description using a collection returned from getNgramCollections, searches for a string and returns what comes before and after it
 * @param  {string} searchText - the string to search for
 * @param  {NGramSequence|NGramCollection} collectionOrSequence - an array of ngrams, or an nGramCollection
 * @param  {number} [siblingSize=1] - how many siblings to find in front or behind
 * @returns {SiblingsFrequencyMap} - a Map with the keys 'before' and 'after' which contain maps of what comes before and after
 * @example
 *    const words = ['revolution', 'nation'];
    const ngramCollections = Methodius.getNgramCollections(words, 2);
    const onSiblings = Methodius.getNgramSiblings('io', ngramCollections);
    onSiblings === new Map([
      ['before', new Map(
        ['ti', 2]
      )],
      ['after', new Map(
        ['on', 2]
      )]
    ])
 */ function $e88a8410e9f2a944$var$getNgramSiblings(searchText, collectionOrSequence, siblingSize = 1) {
    const ngramSiblings = new Map([
        [
            'before',
            new Map()
        ],
        [
            'after',
            new Map()
        ]
    ]);
    if (!searchText) return ngramSiblings;
    const isSequence = typeof collectionOrSequence[0] === 'string';
    const collection = isSequence ? [
        [
            ...collectionOrSequence
        ]
    ] : collectionOrSequence;
    collection.forEach((ngramSequence)=>{
        const ngramIndex = ngramSequence.indexOf(searchText);
        if (ngramIndex > -1) {
            const isFirst = ngramIndex === 0;
            const isLast = ngramIndex === ngramSequence.length - 1;
            const siblingsSliceStart = isFirst ? 0 : ngramIndex - siblingSize;
            const siblingsSliceEnd = isLast ? ngramSequence.length : ngramIndex + siblingSize + 1;
            const siblingsSlice = ngramSequence.slice(siblingsSliceStart, siblingsSliceEnd);
            const siblingsSliceSearchIndex = siblingsSlice.indexOf(searchText);
            siblingsSlice.forEach((sibling, siblingIndex)=>{
                var _a, _b;
                if (siblingIndex === siblingsSliceSearchIndex) return;
                const siblingPosition = siblingIndex < siblingsSliceSearchIndex ? 'before' : 'after';
                const hasSibling = (_a = ngramSiblings.get(siblingPosition)) === null || _a === void 0 ? void 0 : _a.has(sibling);
                if (!hasSibling) (_b = ngramSiblings.get(siblingPosition)) === null || _b === void 0 || _b.set(sibling, 1);
                else {
                    const currentPosition = ngramSiblings === null || ngramSiblings === void 0 ? void 0 : ngramSiblings.get(siblingPosition);
                    const currentPositionCountOfSibling = (currentPosition === null || currentPosition === void 0 ? void 0 : currentPosition.get(sibling)) || 0; // only here to appease TS
                    currentPosition === null || currentPosition === void 0 || currentPosition.set(sibling, currentPositionCountOfSibling + 1);
                }
            });
        }
    });
    return ngramSiblings;
}
module.exports.getNgramSiblings = $e88a8410e9f2a944$var$getNgramSiblings;
/**
 *
 * @description Recursively creates a nested tree of ngrams from a  where the innermost part will be bigrams
 * @param  {Word|NGram} word - a word from which the tree is created
 * @returns {NGramTree | NGramSequence} - a tree of ngrams
 */ function $e88a8410e9f2a944$var$getNgramTree(word) {
    if (!word || typeof word !== 'string') throw new Error('getNgramTree requires a word');
    const wordLength = (word === null || word === void 0 ? void 0 : word.length) || 0;
    const ngramSize = wordLength - 1;
    if (ngramSize < 2) return (0, $3oIXy.getNGrams)(word, 1);
    const ngrams = (0, $3oIXy.getNGrams)(word, ngramSize);
    const ngramTree = new $e88a8410e9f2a944$var$ngramtree_class_1.default();
    ngrams.forEach((ngram)=>{
        if (ngramTree.has(ngram)) return;
        if (ngram.length >= 2) ngramTree.set(ngram, $e88a8410e9f2a944$var$getNgramTree(ngram));
    });
    return ngramTree;
}
module.exports.getNgramTree = $e88a8410e9f2a944$var$getNgramTree;
/**
 * @description creates a map of words with their respective ngram trees
 * @param  {Word[]} words -the words from which ngram trees are created
 * @returns {NGramTreeCollection} A collection of ngram trees
 */ function $e88a8410e9f2a944$var$getNgramTreeCollection(words) {
    const ngramTreeCollection = new Map();
    const uniqueWords = [
        ...new Set(words)
    ];
    uniqueWords.forEach((word)=>{
        if (word && !ngramTreeCollection.has(word)) ngramTreeCollection.set(word, $e88a8410e9f2a944$var$getNgramTree(word));
    });
    return ngramTreeCollection;
}
module.exports.getNgramTreeCollection = $e88a8410e9f2a944$var$getNgramTreeCollection;
/**
 * @description gets the ngrams that occur before and after other ngrams
 * @param  {Word[]} words - an array of words
 * @param  {FrequencyMap} ngrams - a frequency map of ngrams
 * @param  {number} [ngramSize=2] - the size of the ngram
 * @returns {FrequencyMap} - a map of ngrams and their frequencies
 */ function $e88a8410e9f2a944$var$getRelatedNgrams(words, ngrams, ngramSize = 2) {
    if (!words || !ngrams) throw new Error('getRelatedNgrams requires an array of words and an array of ngrams');
    const relatedNgrams = new Map();
    // now,go through words
    words.forEach((word)=>{
        // let's split the word back into ngrams.
        const wordNgrams = (0, $3oIXy.getNGrams)(word, ngramSize);
        // loop through our freshly split ngrams
        wordNgrams.forEach((ngram, ngramIndex)=>{
            // we want the one before and the one after
            const previousNgram = wordNgrams[ngramIndex - 1];
            const nextNgram = wordNgrams[ngramIndex + 1];
            const hasPrevAndCurrent = ngrams.has(previousNgram) && ngrams.has(ngram);
            const hasNextAndCurrent = ngrams.has(ngram) && ngrams.has(nextNgram);
            // we have a case where it's either previous and current are both common,
            // or current and next are both common
            if (hasPrevAndCurrent || hasNextAndCurrent) {
                // our list didn't have it, so we add it
                if (!relatedNgrams.has(ngram)) relatedNgrams.set(ngram, 1);
                else relatedNgrams.set(ngram, relatedNgrams.get(ngram) + 1);
            }
        });
    });
    return relatedNgrams;
}
module.exports.getRelatedNgrams = $e88a8410e9f2a944$var$getRelatedNgrams;

});
parcelRegister("4HGad", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h0bLR = parcelRequire("h0bLR");
/**
 * @augments Map
 * @description a nested map of maps of ngrams formed from a single word where the deepest structure is an array of bigrams
 */ // This is a class that's recursive; it can contain a map of itself or an array of ngrams. ESLint doesn't know this.
/* eslint-disable-next-line no-use-before-define */ class $36cbe268bdb0a252$var$NGramTree extends Map {
    // I know eslint thinks this is useless, but I want to clearly communicate how I expect this to be used.
    /* eslint-disable-next-line no-useless-constructor */ constructor(iterable){
        super(iterable);
    }
    /**
     * @description flattens the tree into an array
     * @param  {number} [ngramSize = 2] the size of the ngrams to include in the array
     * @returns {NGram[]} - a flattened array of ngrams
     */ flatten(ngramSize = 2) {
        const ngramArray = [];
        this.forEach((value, key)=>{
            const hasTree = value instanceof $36cbe268bdb0a252$var$NGramTree;
            const hasTreeSmallerThanNGramSize = hasTree && ngramSize > (value === null || value === void 0 ? void 0 : value.ngramSize);
            if (!hasTree || hasTreeSmallerThanNGramSize) ngramArray.push(key);
            else ngramArray.push(...value.flatten(ngramSize));
        });
        return [
            ...new Set(ngramArray)
        ];
    }
    /**
     * @description will return the rounded average length of an ngram in the map
     * @returns {number} - the average length of an ngram in the map
     * @readonly
     */ get ngramSize() {
        // look, ideally all keys would be the same size but let's not assume that to be true
        const keys = [
            ...this.keys()
        ];
        const meanKeySize = (0, $h0bLR.getMeanWordSize)(keys);
        return Math.round(meanKeySize);
    }
    /**
     * @description will return the depth of the tree
     * @returns {number} - the depth of the tree (0 means this is a map of bigrams)
     * @readonly
     */ get depth() {
        let depth = 0;
        if (this.ngramSize > 2) {
            const firstItem = this.values().next().value;
            const firstItemDepth = firstItem.depth;
            depth = firstItemDepth + 1;
        }
        return depth;
    }
    /**
     * @description will determine if any part of the tree contains the ngram
     * @param  {NGram} ngram - an ngram
     * @returns {boolean} whether the tree contains the ngram
     */ hasDeep(ngram) {
        const nGramSize = ngram.length;
        if (!nGramSize) return false;
        const ngramsOfMatchingSize = this.flatten(ngram.length);
        const hasNGram = ngramsOfMatchingSize.includes(ngram);
        // for sake of performance, don't try a partial match unless it comes up false in the keys
        return hasNGram || ngramsOfMatchingSize.some((ngramOfMatchingSize)=>ngramOfMatchingSize.includes(ngram));
    }
    /**
     * @description convenience method for hasDeep that determines if _all_ ngrams are present in the tree
     * @param {NGram[]} ngrams - an array of ngrams
     * @returns {boolean} whether the tree contains all of the ngrams
     */ hasMany(ngrams) {
        const hasMany = ngrams.every((ngram)=>this.hasDeep(ngram));
        return hasMany;
    }
    /**
     * @description will determine if all of the ngrams are contained in the tree
     * @param {NGram[]} ngrams - an array of ngrams
     * @returns {boolean} whether the tree contains any of the ngrams
     */ hasAny(ngrams) {
        const hasMany = ngrams.some((ngram)=>this.hasDeep(ngram));
        return hasMany;
    }
    /**
     * @description will return an array of ngrams that are present in the tree based on the array provided
     * @param  {NGram[]} ngrams - an array of ngrams
     * @returns {NGram[]} - an array of ngrams that are present in the tree
     */ hasWhich(ngrams) {
        const hasWhich = ngrams.filter((ngram)=>this.hasDeep(ngram));
        return hasWhich;
    }
    /**
     * @description will return the key that contains the ngram you provide it
     * @param  {NGram[]|NGram} ngram - either a string that's an ngram or an array of ngrams
     * @returns {string|[string]} - the key that contains the ngram
     */ keyContaining(ngram) {
        let ngramSequence = ngram;
        if (!Array.isArray(ngram)) ngramSequence = [
            ngram
        ];
        const ngramSize = ngramSequence[0].length;
        let keyContaining = '';
        this.forEach((value, key)=>{
            if (value instanceof $36cbe268bdb0a252$var$NGramTree && value.hasMany(ngramSequence)) {
                if (key.length === ngramSize + 1) keyContaining = key;
                else keyContaining = value.keyContaining(ngramSequence);
            }
            // if the value is an array, this is the smallest set we can go
            // that means the key is two letters and the array should have single letters
            // there's a fun edge case where, given "t" and "[at, ti]", it occurs in both. So we need to return two keys
            if (Array.isArray(value)) {
                const hasSome = value.includes(ngramSequence[0]);
                if (hasSome) {
                    if (!keyContaining) keyContaining = key;
                    else keyContaining = [
                        keyContaining,
                        key
                    ];
                }
            }
        });
        return keyContaining;
    }
}
module.exports.default = $36cbe268bdb0a252$var$NGramTree;

});



var $8660d1d8b4827d96$exports = {};
"use strict";
var $8660d1d8b4827d96$var$__importDefault = $8660d1d8b4827d96$exports && $8660d1d8b4827d96$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8660d1d8b4827d96$exports, "__esModule", {
    value: true
});
$8660d1d8b4827d96$exports.Methodius = void 0;

// this doesn't build properly with exported class if this isn't exported as default
/* eslint-disable-next-line import/no-named-default */ const $8660d1d8b4827d96$var$methodius_class_1 = $8660d1d8b4827d96$var$__importDefault((parcelRequire("e59Pk")));
Object.defineProperty($8660d1d8b4827d96$exports, "Methodius", {
    enumerable: true,
    get: function() {
        return $8660d1d8b4827d96$var$methodius_class_1.default;
    }
});


var $f2ac74c63282ab9d$require$Methodius = $8660d1d8b4827d96$exports.Methodius;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = window, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$n = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(n, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, n)=>{
    $3233927aa82734f9$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $3233927aa82734f9$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $27fcf98b67c2a783$var$s;
const $27fcf98b67c2a783$var$e = window, $27fcf98b67c2a783$var$r = $27fcf98b67c2a783$var$e.trustedTypes, $27fcf98b67c2a783$var$h = $27fcf98b67c2a783$var$r ? $27fcf98b67c2a783$var$r.emptyScript : "", $27fcf98b67c2a783$var$o = $27fcf98b67c2a783$var$e.reactiveElementPolyfillSupport, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $27fcf98b67c2a783$var$l = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
}, $27fcf98b67c2a783$var$d = "finalized";
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $27fcf98b67c2a783$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $27fcf98b67c2a783$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d)) return !1;
        this[$27fcf98b67c2a783$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $3233927aa82734f9$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $3233927aa82734f9$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $3233927aa82734f9$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $27fcf98b67c2a783$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $27fcf98b67c2a783$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d] = !0, $27fcf98b67c2a783$export$c7c07a37856565d.elementProperties = new Map, $27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $27fcf98b67c2a783$var$o || $27fcf98b67c2a783$var$o({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), (null !== ($27fcf98b67c2a783$var$s = $27fcf98b67c2a783$var$e.reactiveElementVersions) && void 0 !== $27fcf98b67c2a783$var$s ? $27fcf98b67c2a783$var$s : $27fcf98b67c2a783$var$e.reactiveElementVersions = []).push("1.6.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $e5ed8027d647799b$var$t;
const $e5ed8027d647799b$var$i = window, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i.trustedTypes, $e5ed8027d647799b$var$e = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$o = "$lit$", $e5ed8027d647799b$var$n = `lit$${(Math.random() + "").slice(9)}$`, $e5ed8027d647799b$var$l = "?" + $e5ed8027d647799b$var$n, $e5ed8027d647799b$var$h = `<${$e5ed8027d647799b$var$l}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$u = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$c = Array.isArray, $e5ed8027d647799b$var$v = (t)=>$e5ed8027d647799b$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $e5ed8027d647799b$var$a = "[ \t\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$_ = /-->/g, $e5ed8027d647799b$var$m = />/g, $e5ed8027d647799b$var$p = RegExp(`>|${$e5ed8027d647799b$var$a}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$a}*=${$e5ed8027d647799b$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$g = /'/g, $e5ed8027d647799b$var$$ = /"/g, $e5ed8027d647799b$var$y = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$w(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$w(2), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$E = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129, null, !1);
function $e5ed8027d647799b$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$e ? $e5ed8027d647799b$var$e.createHTML(i) : i;
}
const $e5ed8027d647799b$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $e5ed8027d647799b$var$f ? "!--" === c[1] ? u = $e5ed8027d647799b$var$_ : void 0 !== c[1] ? u = $e5ed8027d647799b$var$m : void 0 !== c[2] ? ($e5ed8027d647799b$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $e5ed8027d647799b$var$p) : void 0 !== c[3] && (u = $e5ed8027d647799b$var$p) : u === $e5ed8027d647799b$var$p ? ">" === c[0] ? (u = null != l ? l : $e5ed8027d647799b$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $e5ed8027d647799b$var$p : '"' === c[3] ? $e5ed8027d647799b$var$$ : $e5ed8027d647799b$var$g) : u === $e5ed8027d647799b$var$$ || u === $e5ed8027d647799b$var$g ? u = $e5ed8027d647799b$var$p : u === $e5ed8027d647799b$var$_ || u === $e5ed8027d647799b$var$m ? u = $e5ed8027d647799b$var$f : (u = $e5ed8027d647799b$var$p, l = void 0);
        const w = u === $e5ed8027d647799b$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $e5ed8027d647799b$var$o + s.slice(v) + $e5ed8027d647799b$var$n + w) : s + $e5ed8027d647799b$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $e5ed8027d647799b$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $e5ed8027d647799b$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $e5ed8027d647799b$var$V(t, i);
        if (this.el = $e5ed8027d647799b$var$N.createElement(a, e), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $e5ed8027d647799b$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($e5ed8027d647799b$var$o) || i.startsWith($e5ed8027d647799b$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $e5ed8027d647799b$var$o).split($e5ed8027d647799b$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $e5ed8027d647799b$var$H : "?" === i[1] ? $e5ed8027d647799b$var$L : "@" === i[1] ? $e5ed8027d647799b$var$z : $e5ed8027d647799b$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($e5ed8027d647799b$var$y.test(h.tagName)) {
                    const t = h.textContent.split($e5ed8027d647799b$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $e5ed8027d647799b$var$u()), $e5ed8027d647799b$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $e5ed8027d647799b$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $e5ed8027d647799b$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($e5ed8027d647799b$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $e5ed8027d647799b$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $e5ed8027d647799b$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $e5ed8027d647799b$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $e5ed8027d647799b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $e5ed8027d647799b$var$r).importNode(s, !0);
        $e5ed8027d647799b$var$C.currentNode = o;
        let n = $e5ed8027d647799b$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $e5ed8027d647799b$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $e5ed8027d647799b$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $e5ed8027d647799b$var$C.nextNode(), l++);
        }
        return $e5ed8027d647799b$var$C.currentNode = $e5ed8027d647799b$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$S(this, t, i), $e5ed8027d647799b$var$d(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $e5ed8027d647799b$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $e5ed8027d647799b$var$N.createElement($e5ed8027d647799b$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $e5ed8027d647799b$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$E.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$E.set(t.strings, i = new $e5ed8027d647799b$var$N(t)), i;
    }
    T(t) {
        $e5ed8027d647799b$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$R(this.k($e5ed8027d647799b$var$u()), this.k($e5ed8027d647799b$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $e5ed8027d647799b$var$S(this, t, i, 0), n = !$e5ed8027d647799b$var$d(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $e5ed8027d647799b$var$S(this, e[s + l], i, l), h === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$e5ed8027d647799b$var$d(h) || h !== this._$AH[l]), h === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $e5ed8027d647799b$var$I = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $e5ed8027d647799b$var$I) : this.element.removeAttribute(this.name);
    }
}
class $e5ed8027d647799b$var$z extends $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $e5ed8027d647799b$var$S(this, t, i, 0)) && void 0 !== s ? s : $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $e5ed8027d647799b$export$45b790e32b2810ee && e !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (e === $e5ed8027d647799b$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$S(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    O: $e5ed8027d647799b$var$o,
    P: $e5ed8027d647799b$var$n,
    A: $e5ed8027d647799b$var$l,
    C: 1,
    M: $e5ed8027d647799b$var$V,
    L: $e5ed8027d647799b$var$M,
    R: $e5ed8027d647799b$var$v,
    D: $e5ed8027d647799b$var$S,
    I: $e5ed8027d647799b$var$R,
    V: $e5ed8027d647799b$var$k,
    H: $e5ed8027d647799b$var$L,
    N: $e5ed8027d647799b$var$z,
    U: $e5ed8027d647799b$var$H,
    F: $e5ed8027d647799b$var$Z
}, $e5ed8027d647799b$var$B = $e5ed8027d647799b$var$i.litHtmlPolyfillSupport;
null == $e5ed8027d647799b$var$B || $e5ed8027d647799b$var$B($e5ed8027d647799b$var$N, $e5ed8027d647799b$var$R), (null !== ($e5ed8027d647799b$var$t = $e5ed8027d647799b$var$i.litHtmlVersions) && void 0 !== $e5ed8027d647799b$var$t ? $e5ed8027d647799b$var$t : $e5ed8027d647799b$var$i.litHtmlVersions = []).push("2.8.0");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $e5ed8027d647799b$var$R(i.insertBefore($e5ed8027d647799b$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $fe586ba0757c37f7$var$l, $fe586ba0757c37f7$var$o;
const $fe586ba0757c37f7$export$8bf27daf9e8907c9 = (0, $27fcf98b67c2a783$export$c7c07a37856565d);
class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $27fcf98b67c2a783$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157.finalized = !0, $fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, null === ($fe586ba0757c37f7$var$l = globalThis.litElementHydrateSupport) || void 0 === $fe586ba0757c37f7$var$l || $fe586ba0757c37f7$var$l.call(globalThis, {
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$n = globalThis.litElementPolyfillSupport;
null == $fe586ba0757c37f7$var$n || $fe586ba0757c37f7$var$n({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($fe586ba0757c37f7$var$o = globalThis.litElementVersions) && void 0 !== $fe586ba0757c37f7$var$o ? $fe586ba0757c37f7$var$o : globalThis.litElementVersions = []).push("3.3.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $07706bf0c990b886$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b2fdcbe153c88f81$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $b2fdcbe153c88f81$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $b2fdcbe153c88f81$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $b2fdcbe153c88f81$var$e(n, t, o) : $b2fdcbe153c88f81$var$i(n, t);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7162e77b40ffab5c$export$ca000e230c0caa3e(t) {
    return (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $15c76e2f7983b497$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $15c76e2f7983b497$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $15c76e2f7983b497$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e5c3d47edfef3b02$export$b2b799818fbabcf3(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $10a410638b7df95b$export$2fa187e846a241c4(i, n) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $24ba95ebfbdcf6b8$export$dcd0d083aa86c355(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1f45ba04a1effcd1$export$163dfc35cc43f240(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $43ca3aec390b0561$var$n;
const $43ca3aec390b0561$var$e = null != (null === ($43ca3aec390b0561$var$n = window.HTMLSlotElement) || void 0 === $43ca3aec390b0561$var$n ? void 0 : $43ca3aec390b0561$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $43ca3aec390b0561$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $43ca3aec390b0561$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $965e44d5bf066bc5$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}





/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $ead5767561d7cbc1$var$l } = (0, $e5ed8027d647799b$export$8613d1ca9052b22e), $ead5767561d7cbc1$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $ead5767561d7cbc1$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $ead5767561d7cbc1$export$6b6d145ec2a44ca9 = (o, l)=>void 0 === l ? void 0 !== (null == o ? void 0 : o._$litType$) : (null == o ? void 0 : o._$litType$) === l, $ead5767561d7cbc1$export$6a0e8de894d2fcca = (o)=>{
    var l;
    return null != (null === (l = null == o ? void 0 : o._$litType$) || void 0 === l ? void 0 : l.h);
}, $ead5767561d7cbc1$export$2f448fec17d50a3e = (o)=>void 0 !== (null == o ? void 0 : o._$litDirective$), $ead5767561d7cbc1$export$f28e31de6a6eaf32 = (o)=>null == o ? void 0 : o._$litDirective$, $ead5767561d7cbc1$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $ead5767561d7cbc1$var$r = ()=>document.createComment(""), $ead5767561d7cbc1$export$291b2338ad9b0b30 = (o, i, n)=>{
    var t;
    const v = o._$AA.parentNode, d = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = v.insertBefore($ead5767561d7cbc1$var$r(), d), t = v.insertBefore($ead5767561d7cbc1$var$r(), d);
        n = new $ead5767561d7cbc1$var$l(i, t, o, o.options);
    } else {
        const l = n._$AB.nextSibling, i = n._$AM, u = i !== o;
        if (u) {
            let l;
            null === (t = n._$AQ) || void 0 === t || t.call(n, o), n._$AM = o, void 0 !== n._$AP && (l = o._$AU) !== i._$AU && n._$AP(l);
        }
        if (l !== d || u) {
            let o = n._$AA;
            for(; o !== l;){
                const l = o.nextSibling;
                v.insertBefore(o, d), o = l;
            }
        }
    }
    return n;
}, $ead5767561d7cbc1$export$cb8bf9562088e9f4 = (o, l, i = o)=>(o._$AI(l, i), o), $ead5767561d7cbc1$var$s = {}, $ead5767561d7cbc1$export$ea70d9dd5965b1c8 = (o, l = $ead5767561d7cbc1$var$s)=>o._$AH = l, $ead5767561d7cbc1$export$59e9bce518cde500 = (o)=>o._$AH, $ead5767561d7cbc1$export$3133b3144bbba267 = (o)=>{
    var l;
    null === (l = o._$AP) || void 0 === l || l.call(o, !1, !0);
    let i = o._$AA;
    const n = o._$AB.nextSibling;
    for(; i !== n;){
        const o = i.nextSibling;
        i.remove(), i = o;
    }
}, $ead5767561d7cbc1$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e41d1b66de65ecc4$var$u = (e, s, t)=>{
    const r = new Map;
    for(let l = s; l <= t; l++)r.set(e[l], l);
    return r;
}, $e41d1b66de65ecc4$export$76d90c956114f2c2 = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(e){
        if (super(e), e.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).CHILD) throw Error("repeat() can only be used in text expressions");
    }
    ct(e, s, t) {
        let r;
        void 0 === t ? t = s : void 0 !== s && (r = s);
        const l = [], o = [];
        let i = 0;
        for (const s of e)l[i] = r ? r(s, i) : i, o[i] = t(s, i), i++;
        return {
            values: o,
            keys: l
        };
    }
    render(e, s, t) {
        return this.ct(e, s, t).values;
    }
    update(s, [t, r, c]) {
        var d;
        const a = (0, $ead5767561d7cbc1$export$59e9bce518cde500)(s), { values: p, keys: v } = this.ct(t, r, c);
        if (!Array.isArray(a)) return this.ut = v, p;
        const h = null !== (d = this.ut) && void 0 !== d ? d : this.ut = [], m = [];
        let y, x, j = 0, k = a.length - 1, w = 0, A = p.length - 1;
        for(; j <= k && w <= A;)if (null === a[j]) j++;
        else if (null === a[k]) k--;
        else if (h[j] === v[w]) m[w] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(a[j], p[w]), j++, w++;
        else if (h[k] === v[A]) m[A] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(a[k], p[A]), k--, A--;
        else if (h[j] === v[A]) m[A] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(a[j], p[A]), (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, m[A + 1], a[j]), j++, A--;
        else if (h[k] === v[w]) m[w] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(a[k], p[w]), (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, a[j], a[k]), k--, w++;
        else if (void 0 === y && (y = $e41d1b66de65ecc4$var$u(v, w, A), x = $e41d1b66de65ecc4$var$u(h, j, k)), y.has(h[j])) {
            if (y.has(h[k])) {
                const e = x.get(v[w]), t = void 0 !== e ? a[e] : null;
                if (null === t) {
                    const e = (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, a[j]);
                    (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(e, p[w]), m[w] = e;
                } else m[w] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(t, p[w]), (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, a[j], t), a[e] = null;
                w++;
            } else (0, $ead5767561d7cbc1$export$3133b3144bbba267)(a[k]), k--;
        } else (0, $ead5767561d7cbc1$export$3133b3144bbba267)(a[j]), j++;
        for(; w <= A;){
            const e = (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, m[A + 1]);
            (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(e, p[w]), m[w++] = e;
        }
        for(; j <= k;){
            const e = a[j++];
            null !== e && (0, $ead5767561d7cbc1$export$3133b3144bbba267)(e);
        }
        return this.ut = v, (0, $ead5767561d7cbc1$export$ea70d9dd5965b1c8)(s, m), $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
});


var $a79753e3de1a71aa$exports = {};
var $23dedab6f5f098a6$exports = {};
var $d8df8c5579faf259$exports = {};
const $d8df8c5579faf259$var$udhrPreamble = `Whereas recognition of the inherent dignity and of the equal and inalienable rights of all members of the human family is the foundation of freedom, justice and peace in the world,

Whereas disregard and contempt for human rights have resulted in barbarous acts which have outraged the conscience of mankind, and the advent of a world in which human beings shall enjoy freedom of speech and belief and freedom from fear and want has been proclaimed as the highest aspiration of the common people,

Whereas it is essential, if man is not to be compelled to have recourse, as a last resort, to rebellion against tyranny and oppression, that human rights should be protected by the rule of law,

Whereas it is essential to promote the development of friendly relations between nations,

Whereas the peoples of the United Nations have in the Charter reaffirmed their faith in fundamental human rights, in the dignity and worth of the human person and in the equal rights of men and women and have determined to promote social progress and better standards of life in larger freedom,

Whereas Member States have pledged themselves to achieve, in co-operation with the United Nations, the promotion of universal respect for and observance of human rights and fundamental freedoms,

Whereas a common understanding of these rights and freedoms is of the greatest importance for the full realization of this pledge,

Now, therefore,

The General Assembly,

Proclaims this Universal Declaration of Human Rights as a common standard of achievement for all peoples and all nations, to the end that every individual and every organ of society, keeping this Declaration constantly in mind, shall strive by teaching and education to promote respect for these rights and freedoms and by progressive measures, national and international, to secure their universal and effective recognition and observance, both among the peoples of Member States themselves and among the peoples of territories under their jurisdiction. 
`;
const $d8df8c5579faf259$var$udhr1 = `
All human beings are born free and equal in dignity and rights. They are endowed with reason and conscience and should act towards one another in a spirit of brotherhood.
`;
$d8df8c5579faf259$exports = {
    name: "English",
    udhrPreamble: $d8df8c5579faf259$var$udhrPreamble,
    udhr1: $d8df8c5579faf259$var$udhr1,
    lang: 'en'
};


var $28df12e0840324f3$exports = {};
const $28df12e0840324f3$var$udhrPreamble = `
Considerando que la libertad, la justicia y la paz en el mundo tienen por base el reconocimiento de la dignidad intr\xednseca y de los derechos iguales e inalienables de todos los miembros de la familia humana;

Considerando que el desconocimiento y el menosprecio de los derechos humanos han originado actos de barbarie ultrajantes para la conciencia de la humanidad, y que se ha proclamado, como la aspiraci\xf3n m\xe1s elevada del hombre, el advenimiento de un mundo en que los seres humanos, liberados del temor y de la miseria, disfruten de la libertad de palabra y de la libertad de creencias;

Considerando esencial que los derechos humanos sean protegidos por un r\xe9gimen de Derecho, a fin de que el hombre no se vea compelido al supremo recurso de la rebeli\xf3n contra la tiran\xeda y la opresi\xf3n;

Considerando tambi\xe9n esencial promover el desarrollo de relaciones amistosas entre las naciones;

Considerando que los pueblos de las Naciones Unidas han reafirmado en la Carta su fe en los derechos fundamentales del hombre, en la dignidad y el valor de la persona humana y en la igualdad de derechos de hombres y mujeres, y se han declarado resueltos a promover el progreso social y a elevar el nivel de vida dentro de un concepto m\xe1s amplio de la libertad;

Considerando que los Estados Miembros se han comprometido a asegurar, en cooperaci\xf3n con la Organizaci\xf3n de las Naciones Unidas, el respeto universal y efectivo a los derechos y libertades fundamentales del hombre, y

Considerando que una concepci\xf3n com\xfan de estos derechos y libertades es de la mayor importancia para el pleno cumplimiento de dicho compromiso;

Ahora, por tanto,

La Asamblea General,

Proclama la presente Declaraci\xf3n Universal de los Derechos Humanos como ideal com\xfan por el que todos los pueblos y naciones deben esforzarse, a fin de que tanto los individuos como las instituciones, inspir\xe1ndose constantemente en ella, promuevan, mediante la ense\xf1anza y la educaci\xf3n, el respeto a estos derechos y libertades, y aseguren, por medidas progresivas de car\xe1cter nacional e internacional, su reconocimiento y aplicaci\xf3n universales y efectivos, tanto entre los pueblos de los Estados Miembros como entre los de los territorios colocados bajo su jurisdicci\xf3n.`;
const $28df12e0840324f3$var$udhr1 = `Todos los seres humanos nacen libres e iguales en dignidad y derechos y, dotados como est\xe1n de raz\xf3n y conciencia, deben comportarse fraternalmente los unos con los otros.`;
$28df12e0840324f3$exports = {
    name: "Spanish",
    udhrPreamble: $28df12e0840324f3$var$udhrPreamble,
    udhr1: $28df12e0840324f3$var$udhr1,
    lang: 'es'
};


var $671705ea166718db$exports = {};
const $671705ea166718db$var$udhrPreamble = `Considerando que o reconhecimento da dignidade inerente a todos os membros da fam\xedlia humana e dos seus direitos iguais e inalien\xe1veis constitui o fundamento da liberdade, da justi\xe7a e da paz no mundo;

Considerando que o desconhecimento e o desprezo dos direitos do Homen conduziram a actos de barb\xe1rie que revoltam a consci\xeancia da Humanidade e que o advento de um mundo em que os seres humanos sejam livres de falar e de crer, libertos do terror e da mis\xe9ria, foi proclamado como a mais alta inspira\xe7\xe3o do Homem;

Considerando que \xe9 essencial a prote\xe7\xe3o dos direitos do Homem atrav\xe9s de um regime de direito, para que o Homem n\xe3o seja compelido, em supremo recurso, \xe0 revolta contra a tirania e a opress\xe3o;

Considerando que \xe9 essencial encorajar o desenvolvimento de rela\xe7\xf5es amistosas entre as na\xe7\xf5es;

Considerando que, na Carta, os povos das Na\xe7\xf5es Unidas proclamam, de novo, a sua f\xe9 nos direitos fundamentais do Homem, na dignidade e no valor da pessoa humana, na igualdade de direitos dos homens e das mulheres e se declaram resolvidos a favorecer o progresso social e a instaurar melhores condi\xe7\xf5es de vida dentro de uma liberdade mais ampla;

Considerando que os Estados membros se comprometeram a promover, em coopera\xe7\xe3o com a Organiza\xe7\xe3o das Na\xe7\xf5es Unidas, o respeito universal e efectivo dos direitos do Homem e das liberdades fundamentais;

Considerando que uma concep\xe7\xe3o comum destes direitos e liberdades \xe9 da mais alta import\xe2ncia para dar plena satisfa\xe7\xe3o a tal compromisso:

A Assembl\xe9ia Geral proclama a presente Declara\xe7\xe3o Universal

dos Direitos Humanos

como ideal comum a atingir por todos os povos e todas as na\xe7\xf5es, a fim de que todos os indiv\xedduos e todos os org\xe3os da sociedade, tendo-a constantemente no esp\xedrito, se esforcem, pelo ensino e pela educa\xe7\xe3o, por desenvolver o respeito desses direitos e liberdades e por promover, por medidas progressivas de ordem nacional e internacional, o seu reconhecimento e a sua aplica\xe7\xe3o universais e efectivos tanto entre as popula\xe7\xf5es dos pr\xf3prios Estados membros como entre as dos territ\xf3rios colocados sob a sua jurisdi\xe7\xe3o. `;
const $671705ea166718db$var$udhr1 = `Todos os seres humanos nascem livres e iguais em dignidade e em direitos. Dotados de raz\xe3o e de consci\xeancia, devem agir uns para com os outros em esp\xedrito de fraternidade. `;
$671705ea166718db$exports = {
    name: "Portuguese",
    udhrPreamble: $671705ea166718db$var$udhrPreamble,
    udhr1: $671705ea166718db$var$udhr1,
    lang: 'pt'
};


var $3b2c81a607797575$exports = {};
const $3b2c81a607797575$var$udhrPreamble = `
Kontuan izanik munduko askatasuna, justizia eta bakea giza familiako kide
guztien berezko duintasunean eta eskubide berdin eta ukaezinetan oinarritzen
direla;
Kontuan izanik giza eskubideak ez ezagutzearen eta gutxiestearen ondorioz,
giza kontzientziari irain egiten dioten basakeriak gertatu izan direla; eta gizon-
emakumeek, beldur eta gabezia orotik aske, hitz egiteko askatasuna eta
sinesmen-askatasuna izango dituzten munduaren etorrera aldarrikatu dela
gizakiaren helburu nagusi;
Kontuan izanik ezinbestekoa dela giza eskubideak zuzenbidezko erregimen
batek babestea, gizakia-tirania eta zapalkuntzaren aurkako azken irtenbidea den
matxinadara jo beharrean aurkitu ez dadin;
Kontuan izanik ezinbestekoa dela, baita ere, herrialdeen artean harreman
lagunkoiak bultzatzea;
Kontuan izanik Nazio Batuetako kide diren herriek gizakiaren oinarrizko
eskubideetan, gizakiaren duintasun eta balioan eta gizonen eta emakumeen
eskubideen arteko berdintasunean duten fedea tinko azaldu dutela Agirian; eta,
askatasunaren ikuspegi zabalago baten barruan, gizarte aurrerakuntza
sustatzeko eta bizitza-maila jasotzeko erabakita daudela adierazi dutela;
Kontuan izanik Estatu Kideek, Nazio Batuen Erakundearekin elkarlanean,
gizakiaren oinarrizko eskubide eta askatasunen begirune orokorra eta
eraginkorra ziurtatzeko hitza eman dutela;
Kontuan izanik emandako hitz hori osotasunean betetzeko garrantzi handikoa
dela eskubide eta askatasun horiek berdin ulertzea;
`;
const $3b2c81a607797575$var$udhr1 = `
Gizon-emakume guztiak aske jaiotzen dira, duintasun eta eskubide berberak dituztela; eta ezaguera eta kontzientzia dutenez gero, elkarren artean senide legez jokatu beharra dute.	
`;
$3b2c81a607797575$exports = {
    name: "Basque",
    udhrPreamble: $3b2c81a607797575$var$udhrPreamble,
    udhr1: $3b2c81a607797575$var$udhr1,
    lang: 'eu'
};


var $989a203e15c65038$exports = {};
const $989a203e15c65038$var$udhrPreamble = `Consid\xe9rant que la reconnaissance de la dignit\xe9 inh\xe9rente \xe0 tous les membres de la famille humaine et de leurs droits \xe9gaux et inali\xe9nables constitue le fondement de la libert\xe9, de la justice et de la paix dans le monde.

Consid\xe9rant que la m\xe9connaissance et le m\xe9pris des droits de l'homme ont conduit \xe0 des actes de barbarie qui r\xe9voltent la conscience de l'humanit\xe9 et que l'av\xe8nement d'un monde o\xf9 les \xeatres humains seront libres de parler et de croire, lib\xe9r\xe9s de la terreur et de la mis\xe8re, a \xe9t\xe9 proclam\xe9 comme la plus haute aspiration de l'homme.

Consid\xe9rant qu'il est essentiel que les droits de l'homme soient prot\xe9g\xe9s par un r\xe9gime de droit pour que l'homme ne soit pas contraint, en supr\xeame recours, \xe0 la r\xe9volte contre la tyrannie et l'oppression.

Consid\xe9rant qu'il est essentiel d'encourager le d\xe9veloppement de relations amicales entre nations.

Consid\xe9rant que dans la Charte les peuples des Nations Unies ont proclam\xe9 \xe0 nouveau leur foi dans les droits fondamentaux de l'homme, dans la dignit\xe9 et la valeur de la personne humaine, dans l'\xe9galit\xe9 des droits des hommes et des femmes, et qu'ils se sont d\xe9clar\xe9s r\xe9solus \xe0 favoriser le progr\xe8s social et \xe0 instaurer de meilleures conditions de vie dans une libert\xe9 plus grande.

Consid\xe9rant que les Etats Membres se sont engag\xe9s \xe0 assurer, en coop\xe9ration avec l'Organisation des Nations Unies, le respect universel et effectif des droits de l'homme et des libert\xe9s fondamentales.

Consid\xe9rant qu'une conception commune de ces droits et libert\xe9s est de la plus haute importance pour remplir pleinement cet engagement.

L'Assembl\xe9e g\xe9n\xe9rale proclame la pr\xe9sente D\xe9claration universelle des droits de l'homme comme l'id\xe9al commun \xe0 atteindre par tous les peuples et toutes les nations afin que tous les individus et tous les organes de la soci\xe9t\xe9, ayant cette D\xe9claration constamment \xe0 l'esprit, s'efforcent, par l'enseignement et l'\xe9ducation, de d\xe9velopper le respect de ces droits et libert\xe9s et d'en assurer, par des mesures progressives d'ordre national et international, la reconnaissance et l'application universelles et effectives, tant parmi les populations des Etats Membres eux-m\xeames que parmi celles des territoires plac\xe9s sous leur juridiction.`;
const $989a203e15c65038$var$udhr1 = `Tous les \xeatres humains naissent libres et \xe9gaux en dignit\xe9 et en droits. Ils sont dou\xe9s de raison et de conscience et doivent agir les uns envers les autres dans un esprit de fraternit\xe9.`;
$989a203e15c65038$exports = {
    name: "French",
    udhrPreamble: $989a203e15c65038$var$udhrPreamble,
    udhr1: $989a203e15c65038$var$udhr1,
    lang: 'fr'
};


var $79906511ebf25517$exports = {};
const $79906511ebf25517$var$udhrPreamble = `
\u{5D4}\u{5D5}\u{5D0}\u{5D9}\u{5DC} \u{5D5}\u{5D4}\u{5DB}\u{5E8}\u{5D4} \u{5D1}\u{5DB}\u{5D1}\u{5D5}\u{5D3} \u{5D4}\u{5D8}\u{5D1}\u{5E2}\u{5D9} \u{5DC}\u{5DB}\u{5DC} \u{5D1}\u{5E0}\u{5D9} \u{5DE}\u{5E9}\u{5E4}\u{5D7}\u{5EA} \u{5D4}\u{5D0}\u{5D3}\u{5DD} \u{5D5}\u{5D1}\u{5D6}\u{5DB}\u{5D5}\u{5D9}\u{5D5}\u{5EA}\u{5D9}\u{5D4}\u{5DD} \u{5D4}\u{5E9}\u{5D5}\u{5D5}\u{5EA} \u{5D5}\u{5D4}\u{5D1}\u{5DC}\u{5EA}\u{5D9} \u{5E0}\u{5E4}\u{5E7}\u{5E2}\u{5D5}\u{5EA} \u{5D4}\u{5D5}\u{5D0} \u{5D9}\u{5E1}\u{5D5}\u{5D3} \u{5D4}\u{5D7}\u{5D5}\u{5E4}\u{5E9}, \u{5D4}\u{5E6}\u{5D3}\u{5E7} \u{5D5}\u{5D4}\u{5E9}\u{5DC}\u{5D5}\u{5DD} \u{5D1}\u{5E2}\u{5D5}\u{5DC}\u{5DD}

\u{5D4}\u{5D5}\u{5D0}\u{5D9}\u{5DC} \u{5D5}\u{5D4}\u{5D6}\u{5DC}\u{5D6}\u{5D5}\u{5DC} \u{5D1}\u{5D6}\u{5DB}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5D0}\u{5D3}\u{5DD} \u{5D5}\u{5D1}\u{5D9}\u{5D6}\u{5D5}\u{5D9}\u{5DF} \u{5D4}\u{5D1}\u{5E9}\u{5D9}\u{5DC}\u{5D5} \u{5DE}\u{5E2}\u{5E9}\u{5D9}\u{5DD} \u{5E4}\u{5E8}\u{5D0}\u{5D9}\u{5D9}\u{5DD} \u{5E9}\u{5E4}\u{5D2}\u{5E2}\u{5D5} \u{5E7}\u{5E9}\u{5D4} \u{5D1}\u{5DE}\u{5E6}\u{5E4}\u{5D5}\u{5E0}\u{5D4} \u{5E9}\u{5DC} \u{5D4}\u{5D0}\u{5E0}\u{5D5}\u{5E9}\u{5D5}\u{5EA}, \u{5D1}\u{5E0}\u{5D9}\u{5D9}\u{5DF} \u{5E2}\u{5D5}\u{5DC}\u{5DD} \u{5E9}\u{5D1}\u{5D5} \u{5D9}\u{5D9}\u{5D4}\u{5E0}\u{5D5} \u{5DB}\u{5DC} \u{5D9}\u{5E6}\u{5D5}\u{5E8}\u{5D9} \u{5D0}\u{5E0}\u{5D5}\u{5E9} \u{5DE}\u{5D7}\u{5D9}\u{5E8}\u{5D5}\u{5EA} \u{5D4}\u{5D3}\u{5D9}\u{5D1}\u{5D5}\u{5E8} \u{5D5}\u{5D4}\u{5D0}\u{5DE}\u{5D5}\u{5E0}\u{5D4} \u{5D5}\u{5DE}\u{5DF} \u{5D4}\u{5D7}\u{5D9}\u{5E8}\u{5D5}\u{5EA} \u{5DE}\u{5E4}\u{5D7}\u{5D3} \u{5D5}\u{5DE}\u{5DE}\u{5D7}\u{5E1}\u{5D5}\u{5E8}, \u{5D4}\u{5D5}\u{5DB}\u{5E8}\u{5D6} \u{5DB}\u{5E8}\u{5D0}\u{5E9} \u{5E9}\u{5D0}\u{5D9}\u{5E4}\u{5D5}\u{5EA}\u{5D9}\u{5D5} \u{5E9}\u{5DC} \u{5DB}\u{5DC} \u{5D0}\u{5D3}\u{5DD}

\u{5D4}\u{5D5}\u{5D0}\u{5D9}\u{5DC} \u{5D5}\u{5D4}\u{5DB}\u{5E8}\u{5D7} \u{5D7}\u{5D9}\u{5D5}\u{5E0}\u{5D9} \u{5D4}\u{5D5}\u{5D0} \u{5E9}\u{5D6}\u{5DB}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5D0}\u{5D3}\u{5DD} \u{5EA}\u{5D4}\u{5D9}\u{5D9}\u{5E0}\u{5D4} \u{5DE}\u{5D5}\u{5D2}\u{5E0}\u{5D5}\u{5EA} \u{5D1}\u{5DB}\u{5D5}\u{5D7} \u{5E9}\u{5DC}\u{5D8}\u{5D5}\u{5E0}\u{5D5} \u{5E9}\u{5DC} \u{5D4}\u{5D7}\u{5D5}\u{5E7}, \u{5E9}\u{5DC}\u{5D0} \u{5D9}\u{5D4}\u{5D0} \u{5D4}\u{5D0}\u{5D3}\u{5DD} \u{5D0}\u{5E0}\u{5D5}\u{5E1}, \u{5DB}\u{5DE}\u{5E4}\u{5DC}\u{5D8} \u{5D0}\u{5D7}\u{5E8}\u{5D5}\u{5DF}, \u{5DC}\u{5D4}\u{5E9}\u{5DC}\u{5D9}\u{5DA} \u{5D0}\u{5EA} \u{5D9}\u{5D4}\u{5D1}\u{5D5} \u{5E2}\u{5DC} \u{5DE}\u{5E8}\u{5D9}\u{5D3}\u{5D4} \u{5D1}\u{5E2}\u{5E8}\u{5D9}\u{5E6}\u{5D5}\u{5EA} \u{5D5}\u{5D1}\u{5D3}\u{5D9}\u{5DB}\u{5D5}\u{5D9}

\u{5D4}\u{5D5}\u{5D0}\u{5D9}\u{5DC} \u{5D5}\u{5D4}\u{5DB}\u{5E8}\u{5D7} \u{5D7}\u{5D9}\u{5D5}\u{5E0}\u{5D9} \u{5D4}\u{5D5}\u{5D0} \u{5DC}\u{5E7}\u{5D3}\u{5DD} \u{5D0}\u{5EA} \u{5D4}\u{5EA}\u{5E4}\u{5EA}\u{5D7}\u{5D5}\u{5EA}\u{5DD} \u{5E9}\u{5DC} \u{5D9}\u{5D7}\u{5E1}\u{5D9} \u{5D9}\u{5D3}\u{5D9}\u{5D3}\u{5D5}\u{5EA} \u{5D1}\u{5D9}\u{5DF} \u{5D4}\u{5D0}\u{5D5}\u{5DE}\u{5D5}\u{5EA}

\u{5D4}\u{5D5}\u{5D0}\u{5D9}\u{5DC} \u{5D5}\u{5D4}\u{5E2}\u{5DE}\u{5D9}\u{5DD} \u{5D4}\u{5DE}\u{5D0}\u{5D5}\u{5D2}\u{5D3}\u{5D9}\u{5DD} \u{5D1}\u{5D0}\u{5E8}\u{5D2}\u{5D5}\u{5DF} \u{5D4}\u{5D0}\u{5D5}\u{5DE}\u{5D5}\u{5EA} \u{5D4}\u{5DE}\u{5D0}\u{5D5}\u{5D7}\u{5D3}\u{5D5}\u{5EA} \u{5D7}\u{5D6}\u{5E8}\u{5D5} \u{5D5}\u{5D0}\u{5D9}\u{5E9}\u{5E8}\u{5D5} \u{5D1}\u{5DE}\u{5D2}\u{5D9}\u{5DC}\u{5D4} \u{5D0}\u{5EA} \u{5D0}\u{5DE}\u{5D5}\u{5E0}\u{5EA}\u{5DD} \u{5D1}\u{5D6}\u{5DB}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5D9}\u{5E1}\u{5D5}\u{5D3} \u{5E9}\u{5DC} \u{5D4}\u{5D0}\u{5D3}\u{5DD}, \u{5D1}\u{5DB}\u{5D1}\u{5D5}\u{5D3}\u{5D4} \u{5D5}\u{5D1}\u{5E2}\u{5E8}\u{5DB}\u{5D4} \u{5E9}\u{5DC} \u{5D0}\u{5D9}\u{5E9}\u{5D9}\u{5D5}\u{5EA}\u{5D5} \u{5D5}\u{5D1}\u{5D6}\u{5DB}\u{5D5}\u{5EA} \u{5E9}\u{5D5}\u{5D5}\u{5D4} \u{5DC}\u{5D2}\u{5D1}\u{5E8} \u{5D5}\u{5DC}\u{5D0}\u{5D9}\u{5E9}\u{5D4} \u{5D5}\u{5DE}\u{5E0}\u{5D5}\u{5D9} \u{5D5}\u{5D2}\u{5DE}\u{5D5}\u{5E8} \u{5D0}\u{5EA}\u{5DD} \u{5DC}\u{5E1}\u{5D9}\u{5D9}\u{5E2} \u{5DC}\u{5E7}\u{5D9}\u{5D3}\u{5DE}\u{5D4} \u{5D7}\u{5D1}\u{5E8}\u{5EA}\u{5D9}\u{5EA} \u{5D5}\u{5DC}\u{5D4}\u{5E2}\u{5DC}\u{5D0}\u{5EA} \u{5E8}\u{5DE}\u{5EA} \u{5D4}\u{5D7}\u{5D9}\u{5D9}\u{5DD} \u{5DE}\u{5EA}\u{5D5}\u{5DA} \u{5D9}\u{5EA}\u{5E8} \u{5D7}\u{5D9}\u{5E8}\u{5D5}\u{5EA}

\u{5D4}\u{5D5}\u{5D0}\u{5D9}\u{5DC} \u{5D5}\u{5D4}\u{5DE}\u{5D3}\u{5D9}\u{5E0}\u{5D5}\u{5EA} \u{5D4}\u{5D7}\u{5D1}\u{5E8}\u{5D5}\u{5EA} \u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5D5} \u{5DC}\u{5E4}\u{5E2}\u{5D5}\u{5DC}, \u{5D1}\u{5E9}\u{5D9}\u{5EA}\u{5D5}\u{5E3} \u{5E2}\u{5DD} \u{5D0}\u{5E8}\u{5D2}\u{5D5}\u{5DF} \u{5D4}\u{5D0}\u{5D5}\u{5DE}\u{5D5}\u{5EA} \u{5D4}\u{5DE}\u{5D0}\u{5D5}\u{5D7}\u{5D3}\u{5D5}\u{5EA}, \u{5DC}\u{5D8}\u{5D9}\u{5E4}\u{5D5}\u{5D7} \u{5D9}\u{5D7}\u{5E1} \u{5DB}\u{5D1}\u{5D5}\u{5D3} \u{5DB}\u{5DC}\u{5DC}\u{5D9} \u{5D0}\u{5DC} \u{5D6}\u{5DB}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5D0}\u{5D3}\u{5DD} \u{5D5}\u{5D0}\u{5DC} \u{5D7}\u{5D9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5D9}\u{5E1}\u{5D5}\u{5D3} \u{5D5}\u{5D4}\u{5E7}\u{5E4}\u{5D3}\u{5D4} \u{5E2}\u{5DC} \u{5E7}\u{5D9}\u{5D5}\u{5DE}\u{5DF}

\u{5D4}\u{5D5}\u{5D0}\u{5D9}\u{5DC} \u{5D5}\u{5D4}\u{5D1}\u{5E0}\u{5D4} \u{5DE}\u{5E9}\u{5D5}\u{5EA}\u{5E4}\u{5EA} \u{5D1}\u{5DE}\u{5D4}\u{5D5}\u{5EA}\u{5DF} \u{5E9}\u{5DC} \u{5D6}\u{5DB}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D5}\u{5D7}\u{5D9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D0}\u{5DC}\u{5D4} \u{5D4}\u{5D9}\u{5D0} \u{5EA}\u{5E0}\u{5D0}\u{5D9} \u{5D7}\u{5E9}\u{5D5}\u{5D1} \u{5DC}\u{5E7}\u{5D9}\u{5D5}\u{5DE}\u{5D4} \u{5D4}\u{5E9}\u{5DC}\u{5DD} \u{5E9}\u{5DC} \u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5D5}\u{5EA} \u{5D6}\u{5D5}

\u{5DC}\u{5E4}\u{5D9}\u{5DB}\u{5DA} \u{5DE}\u{5DB}\u{5E8}\u{5D9}\u{5D6}\u{5D4} \u{5D4}\u{5E2}\u{5E6}\u{5E8}\u{5EA} \u{5D1}\u{5D0}\u{5D5}\u{5D6}\u{5E0}\u{5D9} \u{5DB}\u{5DC} \u{5D1}\u{5D0}\u{5D9} \u{5D4}\u{5E2}\u{5D5}\u{5DC}\u{5DD} \u{5D0}\u{5EA} \u{5D4}\u{5D4}\u{5DB}\u{5E8}\u{5D6}\u{5D4} \u{5D4}\u{5D6}\u{5D0}\u{5EA} \u{5D1}\u{5D3}\u{5D1}\u{5E8} \u{5D6}\u{5DB}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5D0}\u{5D3}\u{5DD} \u{5DB}\u{5E8}\u{5DE}\u{5EA} \u{5D4}\u{5D9}\u{5E9}\u{5D2}\u{5D9}\u{5DD} \u{5DB}\u{5DC}\u{5DC}\u{5D9}\u{5EA} \u{5DC}\u{5DB}\u{5DC} \u{5D4}\u{5E2}\u{5DE}\u{5D9}\u{5DD} \u{5D5}\u{5D4}\u{5D0}\u{5D5}\u{5DE}\u{5D5}\u{5EA}. \u{5DB}\u{5D3}\u{5D9} \u{5E9}\u{5DB}\u{5DC} \u{5D9}\u{5D7}\u{5D9}\u{5D3} \u{5D5}\u{5DB}\u{5DC} \u{5D2}\u{5D5}\u{5E3} \u{5D7}\u{5D1}\u{5E8}\u{5EA}\u{5D9} \u{5D9}\u{5E9}\u{5D5}\u{5D5}\u{5D4} \u{5EA}\u{5DE}\u{5D9}\u{5D3} \u{5DC}\u{5E0}\u{5D2}\u{5D3} \u{5E2}\u{5D9}\u{5E0}\u{5D9}\u{5D5} \u{5D5}\u{5D9}\u{5E9}\u{5D0}\u{5E3} \u{5DC}\u{5D8}\u{5E4}\u{5D7}, \u{5D3}\u{5E8}\u{5DA} \u{5DC}\u{5D9}\u{5DE}\u{5D5}\u{5D3} \u{5D5}\u{5D7}\u{5D9}\u{5E0}\u{5D5}\u{5DA}, \u{5D9}\u{5D7}\u{5E1} \u{5E9}\u{5DC} \u{5DB}\u{5D1}\u{5D5}\u{5D3} \u{5D0}\u{5DC} \u{5D4}\u{5D6}\u{5DB}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D5}\u{5D0}\u{5DC} \u{5D4}\u{5D7}\u{5D9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5DC}\u{5DC}\u{5D5}, \u{5D5}\u{5DC}\u{5D4}\u{5D1}\u{5D8}\u{5D9}\u{5D7} \u{5D1}\u{5D0}\u{5DE}\u{5E6}\u{5E2}\u{5D9}\u{5DD} \u{5D4}\u{5D3}\u{5E8}\u{5D2}\u{5EA}\u{5D9}\u{5D9}\u{5DD}, \u{5DC}\u{5D0}\u{5D5}\u{5DE}\u{5D9}\u{5D9}\u{5DD} \u{5D5}\u{5D1}\u{5D9}\u{5E0}\u{5DC}\u{5D0}\u{5D5}\u{5DE}\u{5D9}\u{5D9}\u{5DD}, \u{5E9}\u{5D4}\u{5D4}\u{5DB}\u{5E8}\u{5D4} \u{5D1}\u{5E2}\u{5E7}\u{5E8}\u{5D5}\u{5E0}\u{5D5}\u{5EA} \u{5D0}\u{5DC}\u{5D4} \u{5D5}\u{5D4}\u{5D4}\u{5E7}\u{5E4}\u{5D3}\u{5D4} \u{5E2}\u{5DC}\u{5D9}\u{5D4}\u{5DD} \u{5EA}\u{5D4}\u{5D0} \u{5DB}\u{5DC}\u{5DC}\u{5D9}\u{5EA} \u{5D5}\u{5D9}\u{5E2}\u{5D9}\u{5DC}\u{5D4} \u{5D1}\u{5E7}\u{5E8}\u{5D1} \u{5D0}\u{5D5}\u{5DB}\u{5DC}\u{5D5}\u{5E1}\u{5D9} \u{5D4}\u{5DE}\u{5D3}\u{5D9}\u{5E0}\u{5D5}\u{5EA} \u{5D4}\u{5D7}\u{5D1}\u{5E8}\u{5D5}\u{5EA} \u{5D5}\u{5D1}\u{5E7}\u{5E8}\u{5D1} \u{5D4}\u{5D0}\u{5D5}\u{5DB}\u{5DC}\u{5D5}\u{5E1}\u{5D9}\u{5DD} \u{5E9}\u{5D1}\u{5D0}\u{5E8}\u{5E6}\u{5D5}\u{5EA} \u{5E9}\u{5D9}\u{5E4}\u{5D5}\u{5D8}\u{5DD}.
`;
const $79906511ebf25517$var$udhr1 = `
\u{5DB}\u{5DC} \u{5D1}\u{5E0}\u{5D9} \u{5D0}\u{5D3}\u{5DD} \u{5E0}\u{5D5}\u{5DC}\u{5D3}\u{5D5} \u{5D1}\u{5E0}\u{5D9} \u{5D7}\u{5D5}\u{5E8}\u{5D9}\u{5DF} \u{5D5}\u{5E9}\u{5D5}\u{5D5}\u{5D9}\u{5DD} \u{5D1}\u{5E2}\u{5E8}\u{5DB}\u{5DD} \u{5D5}\u{5D1}\u{5D6}\u{5DB}\u{5D5}\u{5D9}\u{5D5}\u{5EA}\u{5D9}\u{5D4}\u{5DD}. \u{5DB}\u{5D5}\u{5DC}\u{5DD} \u{5D7}\u{5D5}\u{5E0}\u{5E0}\u{5D5} \u{5D1}\u{5EA}\u{5D1}\u{5D5}\u{5E0}\u{5D4} \u{5D5}\u{5D1}\u{5DE}\u{5E6}\u{5E4}\u{5D5}\u{5DF}, \u{5DC}\u{5E4}\u{5D9}\u{5DB}\u{5DA} \u{5D7}\u{5D5}\u{5D1}\u{5D4} \u{5E2}\u{5DC}\u{5D9}\u{5D4}\u{5DD} \u{5DC}\u{5E0}\u{5D4}\u{5D5}\u{5D2} \u{5D0}\u{5D9}\u{5E9} \u{5D1}\u{5E8}\u{5E2}\u{5D4}\u{5D5} \u{5D1}\u{5E8}\u{5D5}\u{5D7} \u{5E9}\u{5DC} \u{5D0}\u{5D7}\u{5D5}\u{5D5}\u{5D4}.
`;
$79906511ebf25517$exports = {
    name: 'Hebrew',
    udhrPreamble: $79906511ebf25517$var$udhrPreamble,
    udhr1: $79906511ebf25517$var$udhr1,
    direction: 'rtl',
    lang: 'he'
};


var $e1fa0f909afcd87e$exports = {};
const $e1fa0f909afcd87e$var$udhrPreamble = `Overwegende, dat erkenning van de inherente waardigheid en van de gelijke en onvervreemdbare rechten van alle leden van de mensengemeenschap grondslag is voor de vrijheid, gerechtigheid en vrede in de wereld;

Overwegende, dat terzijdestelling van en minachting voor de rechten van de mens geleid hebben tot barbaarse handelingen, die het geweten van de mensheid geweld hebben aangedaan en dat de komst van een wereld, waarin de mensen vrijheid van meningsuiting en geloof zullen genieten, en vrij zullen zijn van vrees en gebrek, is verkondigd als het hoogste ideaal van iedere mens;

Overwegende, dat het van het grootste belang is, dat de rechten van de mens beschermd worden door de suprematie van het recht, opdat de mens niet gedwongen worde om in laatste instantie zijn toevlucht te nemen tot opstand tegen tyrannie en onderdrukking;

Overwegende, dat het van het grootste belang is om de ontwikkeling van vriendschappelijke betrekkingen tussen de naties te bevorderen;

Overwegende, dat de volkeren van de Verenigde Naties in het Handvest hun vertrouwen in de fundamentele rechten van de mens, in de waardigheid en de waarde van de mens en in de gelijke rechten van mannen en vrouwen opnieuw hebben bevestigd, en besloten hebben om sociale vooruitgang en een hogere levensstandaard in groter vrijheid te bevorderen;

Overwegende, dat de Staten, welke Lid zijn van de Verenigde Naties, zich plechtig verbonden hebben om, in samenwerking met de Organisatie van de Verenigde Naties, overal de eerbied voor en inachtneming van de rechten van de mens en de fundamentele vrijheden te bevorderen;

Overwegende, dat het van het grootste belang is voor de volledige nakoming van deze verbintenis, dat een ieder begrip hebbe voor deze rechten en vrijheden;

Op grond daarvan proclameert de Algemene Vergadering deze Universele Verklaring van de Rechten van de Mens als het gemeenschappelijk door alle volkeren en alle naties te bereiken ideaal, opdat ieder individu en elk orgaan van de gemeenschap, met deze verklaring voortdurend voor ogen, er naar zal streven door onderwijs en opvoeding de eerbied voor deze rechten en vrijheden te bevorderen, en door vooruitstrevende maatregelen, op nationaal en internationaal terrein, deze rechten algemeen en daadwerkelijk te doen erkennen en toepassen, zowel onder de volkeren van Staten die Lid van de Verenigde Naties zijn, zelf, als onder de volkeren van gebieden, die onder hun jurisdictie staan:`;
const $e1fa0f909afcd87e$var$udhr1 = `
Alle mensen worden vrij en gelijk in waardigheid en rechten geboren. Zij zijn begiftigd met verstand en geweten, en behoren zich jegens elkander in een geest van broederschap te gedragen.
`;
$e1fa0f909afcd87e$exports = {
    name: "Dutch",
    udhrPreamble: $e1fa0f909afcd87e$var$udhrPreamble,
    udhr1: $e1fa0f909afcd87e$var$udhr1,
    lang: 'nl'
};


var $9561357437e49161$exports = {};
const $9561357437e49161$var$udhrPreamble = `Considerant que el reconeixement de la dignitat inherent i dels drets iguals i inalienables de tots els membres de la fam\xedlia humana \xe9s el fonament de la llibertat, la just\xedcia i la pau en el m\xf3n,

Considerant que el desconeixement i el menyspreu dels drets humans han originat actes de barb\xe0rie que han ultratjat la consci\xe8ncia de la humanitat; i que s'ha proclamat com l'aspiraci\xf3 m\xe9s elevada de tothom l'adveniment d'un m\xf3n on els \xe9ssers humans, deslliurats del temor i la mis\xe8ria, puguin gaudir de llibertat d'expressi\xf3 i de creen\xe7a,

Considerant que \xe9s essencial que els drets humans siguin protegits per un r\xe8gim de dret per tal que les persones no es vegin for\xe7ades, com a \xfaltim recurs, a la rebel_li\xf3 contra la tirania i l'opressi\xf3,

Considerant tamb\xe9 que \xe9s essencial de promoure el desenvolupament de relacions amistoses entre les nacions,

Considerant que els pobles de les Nacions Unides han ratificat en la Carta llur fe en els drets humans fonamentals, en la dignitat i el valor de la persona humana i en la igualtat de dret d'homes i dones; i que han decidit de promoure el progr\xe9s social i millorar el nivell de vida dins d'una llibertat m\xe9s \xe0mplia,

Considerant que els Estats membres s'han comprom\xe8s a assegurar, en cooperaci\xf3 amb l'Organitzaci\xf3 de les Nacions Unides, el respecte universal i efectiu dels drets humans i les llibertats fonamentals,

Considerant que una concepci\xf3 comuna d'aquests drets i llibertats \xe9s de la m\xe9s gran import\xe0ncia per al ple compliment d'aquest comprom\xeds,

L'Assemblea General

Proclama aquesta Declaraci\xf3 Universal de Drets Humans com l'ideal com\xfa a assolir per a tots els pobles i nacions amb el fi que cada persona i cada instituci\xf3, inspirant-se constantment en aquesta Declaraci\xf3, promoguin, mitjan\xe7ant I'ensenyament i l'educaci\xf3, el respecte a aquests drets i llibertats i assegurin, amb mesures progressives nacionals i internacionals, el seu reconeixement i aplicaci\xf3 universals i efectius, tant entre els pobles dels Estats membres com entre els dels territoris sota llur jurisdicci\xf3. `;
const $9561357437e49161$var$udhr1 = `
Tots els \xe9ssers humans neixen lliures i iguals en dignitat i en drets. S\xf3n dotats de ra\xf3 i de consci\xe8ncia, i han de comportar-se fraternalment els uns amb els altres. 
`;
$9561357437e49161$exports = {
    name: 'Catalan',
    udhrPreamble: $9561357437e49161$var$udhrPreamble,
    udhr1: $9561357437e49161$var$udhr1,
    lang: 'ca'
};


var $cba6a8b5be479746$exports = {};
const $cba6a8b5be479746$var$udhrPreamble = `Considerato che il riconoscimento della dignit\xe0 inerente a tutti i membri della famiglia umana e dei loro diritti, uguali ed inalienabili, costituisce il fondamento della libert\xe0, della giustizia e della pace nel mondo;

Considerato che il disconoscimento e il disprezzo dei diritti umani hanno portato ad atti di barbarie che offendono la coscienza dell'umanit\xe0, e che l'avvento di un mondo in cui gli esseri umani godano della libert\xe0 di parola e di credo e della libert\xe0 dal timore e dal bisogno \xe8 stato proclamato come la pi\xf9 alta aspirazione dell'uomo;

Considerato che \xe8 indispensabile che i diritti umani siano protetti da norme giuridiche, se si vuole evitare che l'uomo sia costretto a ricorrere, come ultima istanza, alla ribellione contro la tirannia e l'oppressione;

Considerato che \xe8 indispensabile promuovere lo sviluppo di rapporti amichevoli tra le Nazioni;

Considerato che i popoli delle Nazioni Unite hanno riaffermato nello Statuto la loro fede nei diritti umani fondamentali, nella dignit\xe0 e nel valore della persona umana, nell'uguaglianza dei diritti dell'uomo e della donna, ed hanno deciso di promuovere il progresso sociale e un miglior tenore di vita in una maggiore libert\xe0;

Considerato che gli Stati membri si sono impegnati a perseguire, in cooperazione con le Nazioni Unite, il rispetto e l'osservanza universale dei diritti umani e delle libert\xe0 fondamentali;

Considerato che una concezione comune di questi diritti e di questa libert\xe0 \xe8 della massima importanza per la piena realizzazione di questi impegni;

L'ASSEMBLEA GENERALE

proclama

la presente dichiarazione universale dei diritti umani come ideale comune da raggiungersi da tutti i popoli e da tutte le Nazioni, al fine che ogni individuo ed ogni organo della societ\xe0, avendo costantemente presente questa Dichiarazione, si sforzi di promuovere, con l'insegnamento e l'educazione, il rispetto di questi diritti e di queste libert\xe0 e di garantirne, mediante misure progressive di carattere nazionale e internazionale, l'universale ed effettivo riconoscimento e rispetto tanto fra i popoli degli stessi Stati membri, quanto fra quelli dei territori sottoposti alla loro giurisdizione.`;
const $cba6a8b5be479746$var$udhr1 = `Tutti gli esseri umani nascono liberi ed eguali in dignit\xe0 e diritti. Essi sono dotati di ragione e di coscienza e devono agire gli uni verso gli altri in spirito di fratellanza.`;
$cba6a8b5be479746$exports = {
    name: "Italian",
    udhrPreamble: $cba6a8b5be479746$var$udhrPreamble,
    udhr1: $cba6a8b5be479746$var$udhr1,
    lang: 'it'
};


var $c80287a21426ac92$exports = {};
const $c80287a21426ac92$var$udhrPreamble = `Gan mai cydnabod urddas cynhenid a hawliau cydradd a phriod holl aelodau\u{2019}r teulu dynol yw sylfaen rhyddid, cyfiawnder a heddwch yn y byd,

Gan i anwybyddu a dirmygu hawliau dynol arwain at weithredoedd barbaraidd a dreisiodd gydwybod dynolryw, a bod dyfodiad byd lle y gall pob unigolyn fwynhau rhyddid i siarad a chredu a rhyddid rhag ofn ac angau wedi ei gyhoeddi yn ddyhead uchaf y bobl gyffredin,

Gan fod yn rhaid amddiffyn hawliau dynol a rheolaeth cyfraith, os nad yw pob unigolyn dan orfod yn y pendraw i wrthryfela yn erbyn gormes a thrais,

Gan fod yn rhaid hyrwyddo cysylltiadau cyfeillgar rhwng Cenhedloedd,

Gan fod pobloedd y Cenhedloedd Unedig yn y Siarter wedi ail ddatgan ffydd mewn hawliau sylfaenol yr unigolyn, mewn urddas a gwerth y person dynol ac mewn hawliau cydradd

gwr a gwragedd, ac wedi penderfynu hyrwyddo cynnydd cymdeithasol a safonau byw gwell mewn rhyddid helaethach,

Gan fod y Gwladwriaethau sy'n Aelodau wedi ymrwymo, mewn cydweithrediad \xe2'r Cenhedloedd Unedig, i sicrhau hyrwyddo parch cyffredinol i hawliau dynol a'r rhyddfreintiau sylfaenol, a'u cadw,

Gan fod deall yr hawliau a'r rhyddfreintiau hyn gan bawb o'r pwys mwyaf i lwyr sylweddoli'r ymrwymiad hwn,

Felly, y mae'r

Cynulliad Cyffredinol

yn awr yn cyhoeddi'r

Datganiad Cyffredinol hwn o Hawliau Dynol

yn ddelfryd cyffredin i'r holl bobloedd a'r holl genhedloedd ymgyrraedd ato, fel y bo i bob person ac i bob offeryn cymdeithasol, gan ddal y Datganiad hwn mewn cof yn wastad, ymdrechu trwy ddysgu a hyfforddi i sicrhau parch i'r hawliau a'r rhyddfreintiau hyn, a thrwy ffyrdd blaengar, cenedlaethol a chydgenedlaethol, i sicrhau eu cydnabod a'u cadw yn gyffredinol ac yn effeithiol, ymysg pobloedd y Gwladwriaethau sy'n Aelodau eu hunain yn ogystal ag ymysg pobloedd y tiriogaethau sydd dan eu rheolaeth.
`;
const $c80287a21426ac92$var$udhr1 = `Genir pawb yn rhydd ac yn gydradd \xe2'i gilydd mewn urddas a hawliau. Fe'u cynysgaeddir \xe2 rheswm a chydwybod, a dylai pawb ymddwyn y naill at y llall mewn ysbryd cymodlon.`;
$c80287a21426ac92$exports = {
    name: 'Welsh',
    udhrPreamble: $c80287a21426ac92$var$udhrPreamble,
    udhr1: $c80287a21426ac92$var$udhr1,
    lang: 'cy'
};


var $a48f664eeae2df4c$exports = {};
const $a48f664eeae2df4c$var$udhrPreamble = `Da die Anerkennung der angeborenen W\xfcrde und der gleichen und unver\xe4u\xdferlichen Rechte aller Mitglieder der Gemeinschaft der Menschen die Grundlage von Freiheit, Gerechtigkeit und Frieden in der Welt bildet,

da die Nichtanerkennung und Verachtung der Menschenrechte zu Akten der Barbarei gef\xfchrt haben, die das Gewissen der Menschheit mit Emp\xf6rung erf\xfcllen, und da verk\xfcndet worden ist, da\xdf einer Welt, in der die Menschen Rede- und Glaubensfreiheit und Freiheit von Furcht und Not genie\xdfen, das h\xf6chste Streben des Menschen gilt,

da es notwendig ist, die Menschenrechte durch die Herrschaft des Rechtes zu sch\xfctzen, damit der Mensch nicht gezwungen wird, als letztes Mittel zum Aufstand gegen Tyrannei und Unterdr\xfcckung zu greifen,

da es notwendig ist, die Entwicklung freundschaftlicher Beziehungen zwischen den Nationen zu f\xf6rdern,

da die V\xf6lker der Vereinten Nationen in der Charta ihren Glauben an die grundlegenden Menschenrechte, an die W\xfcrde und den Wert der menschlichen Person und an die Gleichberechtigung von Mann und Frau erneut bekr\xe4ftigt und beschlossen haben, den sozialen Fortschritt und bessere Lebensbedingungen in gr\xf6\xdferer Freiheit zu f\xf6rdern,

da die Mitgliedstaaten sich verpflichtet haben, in Zusammenarbeit mit den Vereinten Nationen auf die allgemeine Achtung und Einhaltung der Menschenrechte und Grundfreiheiten hinzuwirken,

da ein gemeinsames Verst\xe4ndnis dieser Rechte und Freiheiten von gr\xf6\xdfter Wichtigkeit f\xfcr die volle Erf\xfcllung dieser Verpflichtung ist,

verk\xfcndet die Generalversammlung

diese Allgemeine Erkl\xe4rung der Menschenrechte als das von allen V\xf6lkern und Nationen zu erreichende gemeinsame Ideal, damit jeder einzelne und alle Organe der Gesellschaft sich diese Erkl\xe4rung stets gegenw\xe4rtig halten und sich bem\xfchen, durch Unterricht und Erziehung die Achtung vor diesen Rechten und Freiheiten zu f\xf6rdern und durch fortschreitende nationale und internationale Ma\xdfnahmen ihre allgemeine und tats\xe4chliche Anerkennung und Einhaltung durch die Bev\xf6lkerung der Mitgliedstaaten selbst wie auch durch die Bev\xf6lkerung der ihrer Hoheitsgewalt unterstehenden Gebiete zu gew\xe4hrleisten.`;
const $a48f664eeae2df4c$var$udhr1 = `Alle Menschen sind frei und gleich an W\xfcrde und Rechten geboren. Sie sind mit Vernunft und Gewissen begabt und sollen einander im Geist der Br\xfcderlichkeit begegnen.`;
$a48f664eeae2df4c$exports = {
    name: "German",
    udhrPreamble: $a48f664eeae2df4c$var$udhrPreamble,
    udhr1: $a48f664eeae2df4c$var$udhr1,
    lang: 'de'
};


var $146de1b6e4d4d37f$exports = {};
const $146de1b6e4d4d37f$var$udhrPreamble = `De Bhr\xed gurb \xe9 aithint d\xednte d\xfachais agus chearta comhionanna do-shannta an uile dhuine den chine daonna is foras don tsaorise, don cheartas agus don ts\xedoch\xe1in sa domhan,

De Bhr\xed gur thionscain a neamhaird agus an m\xed-mheas ar chearta an duine gn\xedomhartha barbartha a chuir uaf\xe1s ar choinsias an chine daonna, agus go bhfuil for\xf3gartha gurb \xe9 meanmarc is uaisle ag an gcoitiantacht saol a thabhairt i r\xe9im a bh\xe9arfas don duine saoirse chainte agus chreidimh agus saoirse \xf3 eagla agus \xf3 amhgar,

De Bhr\xed go ndearna pobail na N\xe1isi\xfain Aontaithe sa Chairt dearbh\xfa athuair ar a gcreideamh i gcearta bun\xfasacha an duine, i nd\xednit agus i bhfi\xfantas pearsan an duine agus i gcearta comhionanna fear agus bean, agus gur chinneadar tac\xfa leis an ascnamh s\xf3isalach agus r\xe9im maireachtana n\xedos fearr a thabhairt i gcr\xedch faoi shaoirse n\xedos fairsinge,

De Bhr\xed gur ghabhadar na St\xe1t-Chomhalta\xed faoi chuing ghealltanais go nd\xe9anfaid, i gcomhar leis na N\xe1isi\xfain Aontaithe, urraim uile-choiteann \xe9ifeachtach d'\xe1irithi\xfa do chearta agus do shaoirs\xed bun\xfasacha an duine.

De Bhr\xed go bhfuil s\xe9 f\xedor-th\xe1bhachtach, chun an gealltanas sin a chomhalladh ina ioml\xe1ine, go mbeif\xed ar aon-tuiscint maidir leis na cearta agus na saoirs\xed sin,

Anois ar an abhar sin for\xf3grainn an Tion\xf3l Giner\xe1lta an Dearb\xfa Uile-choiteann seo ar Chearta an Duine mar chomhchaighde\xe1n le tabhairt i r\xe9im ag gach pobal agus gach n\xe1isi\xfan ionas go nde\xe1nfaidh gach uile dhuine agus gach uile organ den chomhdhaonnacht, agus iad de sh\xedor ag tabhairt an Dearbhuithe seo d\xe1 n'aire agus d\xe1 n-\xfaidh, d\xedchell, tr\xedd an teagasc agus an t-oideachas, chun urraim do na cearta agus do no saoirs\xed sin a choth\xfa agus chun a \xe1irithi\xfa tr\xedd bearta ascnaimh, n\xe1isi\xfanta agus eadarn\xe1isi\xfanta, go mbeidh aithint agus feidm \xe9ifeathtach uile-choiteann acu, n\xed hamh\xe1in i measc pobal na St\xe1t-Chomhalta\xed f\xe9in, ach f\xf3s i measc pobal na gcr\xedocha at\xe1 faoina ndl\xednse sin`;
const $146de1b6e4d4d37f$var$udhr1 = `Saol\xe1itear na daoine uile saor agus comhionann ina nd\xednit agus ina gcearta. T\xe1 bauidh an r\xe9as\xfain agus an choinsiasa acu agus dl\xedd iad f\xe9in d'iompar de mheon bhrthreachais i leith a ch\xe9ile.`;
$146de1b6e4d4d37f$exports = {
    name: "Irish",
    udhrPreamble: $146de1b6e4d4d37f$var$udhrPreamble,
    udhr1: $146de1b6e4d4d37f$var$udhr1,
    lang: 'ga'
};


var $5063d38873003c4f$exports = {};
const $5063d38873003c4f$var$udhrPreamble = `Visto que la llibert\xe1, la xusticia y la paz en mundu sof\xedtense na reconocencia de la dignid\xe1 intr\xednseca y de los drechos iguales y inayenables de tolos miembros que formen la familia humana;

Visto que desconocer o facer de menos los drechos humanos foi la causa d'actos xabaces y da\xf1ibles pa la conciencia de la humanid\xe1, y que se proclam\xf3, comu aspiraci\xf3n cimera del home, el llogru d'un mundu onde los seres humanos, llibres del mieu y de la llaceria, gocen de la llibert\xe1 de palabra y de la llibert\xe1 de creyencies;

Visto que ye esencial un r\xe9xime de Drechu que protexa los drechos humanos, p'asina nun se ver emburri\xe1u l'home al recursu caberu de rebelase escontra de la tiran\xeda y de la opresi\xf3n;

Visto que ye tami\xe9n esencial promover l'afitamientu de rellaciones amistoses ente les naciones;

Visto que los pueblos dexaron llant\xe1u na Carta de les Naciones Xun\xedes el so enfotu nos drechos fundamentales del home, na dignid\xe1 y nel valor de la persona humana y na iguald\xe1 de drechos d'homes y muyeres, amosando la clara intenci\xf3n de promover el progresu social y de facer espoxigar el nivel de vida seg\xfan un conceutu m\xe1s ampliu de la llibert\xe1;

Visto que los Estaos Miembros comprometi\xe9ronse a asegurar, en comu\xf1a cola Organizaci\xf3n de les Naciones Xun\xedes, el respetu universal y efeutivu a los drechos y llibertaes fundamentales del home; y

Considerando qu'una conceici\xf3n com\xfan d'estos drechos y llibertaes ye bramente importante a fin de percumplir el dichu compromisu;`;
const $5063d38873003c4f$var$udhr1 = `Tolos seres humanos nacen llibres y iguales en dignid\xe1 y drechos y, pola mor de la raz\xf3n y la conciencia de so, han comportase hermaniblemente los unos colos otros.`;
$5063d38873003c4f$exports = {
    name: "Asturian",
    udhrPreamble: $5063d38873003c4f$var$udhrPreamble,
    udhr1: $5063d38873003c4f$var$udhr1,
    lang: 'ast'
};


var $fca0f2ca02b77145$exports = {};
const $fca0f2ca02b77145$var$udhrPreamble = `D\xe5 det \xe5 godkjenne det naturlege menneskeverdet med like og umissande rettar for alle menneske p\xe5 jorda er grunnlaget for fridom, rettferd og fred i verda,

og d\xe5 h\xe5n og v\xf8rdsl\xf8yse mot menneskerettane har f\xf8rt til barbariske handlingar som har skaka samvitet til menneskeretta, er framvoksteren i den verda der menneska skal ha talefridom og trusfridom og vere l\xf8yste fr\xe5 otte og naud, kunngjord som det h\xf8gste m\xe5let for kvart menneske,

og d\xe5 det er n\xf8dvendig at menneskerettane blir verna om av lover slik at menneska ikkje blir tvinga til \xe5 finne den siste utvegen i \xe5 gjere oppr\xf8r mot tyranni og tr\xe6lek\xe5r,

og d\xe5 det er n\xf8dvendig \xe5 arbeide for betre tilh\xf8ve mellom nasjonane,

og d\xe5 folka i Dei Sameinte Nasjonane har stadfest trua si i denne pakta, p\xe5 grunnleggjande menneskerettar, p\xe5 menneskeverd og p\xe5 same rett for mann og kvinne, og har vedteke \xe5 arbeide for sosiale framsteg og betre levevilk\xe5r i st\xf8rre fridom,

og d\xe5 medlemsstatane har bunde seg til \xe5 fremje allmenn v\xf8rdnad for pakta og halde seg etter menneskerettane og den grunnleggjande fridomen i samarbeid med Dei Sameinte Nasjonane,

og d\xe5 denne retten og fridomen m\xe5 bli godkjend av alle dersom pakta skal bli r\xf8yndom,`;
const $fca0f2ca02b77145$var$udhr1 = `Alle menneske er f\xf8dde til fridom og med same menneskeverd og menneskerettar. Dei har f\xe5tt fornuft og samvit og skal leve med kvarandre som br\xf8r.`;
$fca0f2ca02b77145$exports = {
    name: "Norwegian",
    udhrPreamble: $fca0f2ca02b77145$var$udhrPreamble,
    udhr1: $fca0f2ca02b77145$var$udhr1,
    lang: 'nn'
};


var $ef3f7060d4e491a2$exports = {};
const $ef3f7060d4e491a2$var$udhrPreamble = `
En\xe4r erk\xe4nnandet av det inneboende v\xe4rdet hos alla medlemmar av m\xe4nniskosl\xe4ktet och av deras lika och of\xf6rytterliga r\xe4ttigheter \xe4r grundvalen f\xf6r frihet, r\xe4ttvisa och fred i v\xe4rlden,

en\xe4r ringaktning och f\xf6rakt f\xf6r de m\xe4nskliga r\xe4ttigheterna lett till barbariska g\xe4rningar, som uppr\xf6rt m\xe4nsklighetens samvete, och en\xe4r skapandet av en v\xe4rld, d\xe4r m\xe4nniskorna \xe5tnjuta yttrandefrihet, trosfrihet samt frihet fr\xe5n fruktan och n\xf6d, kungjorts som folkens h\xf6gsta str\xe4van,

en\xe4r det \xe4r v\xe4sentligt f\xf6r att icke m\xe4nniskan skall tvingas att som en sista utv\xe4g tillgripa uppror mot tyranni och f\xf6rtryck, att de m\xe4nskliga r\xe4ttigheterna skyddas genom lagens \xf6verh\xf6ghet,

en\xe4r det \xe4r v\xe4sentligt att fr\xe4mja utvecklandet av v\xe4nskapliga f\xf6rbindelser mellan nationerna,

en\xe4r F\xf6renta Nationernas folk i stadgan \xe5nyo uttryckt sin tro p\xe5 de grundl\xe4ggande m\xe4nskliga r\xe4ttigheterna, den enskilda m\xe4nniskans v\xe4rdighet och v\xe4rde samt m\xe4nnens och kvinnornas lika r\xe4ttigheter, \xe4vensom beslutat fr\xe4mja socialt fram\xe5tskridande och b\xe4ttre levnadsvillkor under st\xf6rre frihet,

en\xe4r medlemsstaterna \xe5tagit sig att i samverkan med F\xf6renta Nationerna s\xe4kerst\xe4lla allm\xe4n och effektiv respekt f\xf6r de m\xe4nskliga r\xe4ttigheterna och de grundl\xe4ggande friheterna,

en\xe4r en gemensam uppfattning av dessa fri- och r\xe4ttigheters inneb\xf6rd \xe4r av st\xf6rsta betydelse f\xf6r uppfyllandet av detta \xe5tagande,`;
const $ef3f7060d4e491a2$var$udhr1 = `
En\xe4r erk\xe4nnandet av det inneboende v\xe4rdet hos alla medlemmar av m\xe4nniskosl\xe4ktet och av deras lika och of\xf6rytterliga r\xe4ttigheter \xe4r grundvalen f\xf6r frihet, r\xe4ttvisa och fred i v\xe4rlden,

en\xe4r ringaktning och f\xf6rakt f\xf6r de m\xe4nskliga r\xe4ttigheterna lett till barbariska g\xe4rningar, som uppr\xf6rt m\xe4nsklighetens samvete, och en\xe4r skapandet av en v\xe4rld, d\xe4r m\xe4nniskorna \xe5tnjuta yttrandefrihet, trosfrihet samt frihet fr\xe5n fruktan och n\xf6d, kungjorts som folkens h\xf6gsta str\xe4van,

en\xe4r det \xe4r v\xe4sentligt f\xf6r att icke m\xe4nniskan skall tvingas att som en sista utv\xe4g tillgripa uppror mot tyranni och f\xf6rtryck, att de m\xe4nskliga r\xe4ttigheterna skyddas genom lagens \xf6verh\xf6ghet,

en\xe4r det \xe4r v\xe4sentligt att fr\xe4mja utvecklandet av v\xe4nskapliga f\xf6rbindelser mellan nationerna,

en\xe4r F\xf6renta Nationernas folk i stadgan \xe5nyo uttryckt sin tro p\xe5 de grundl\xe4ggande m\xe4nskliga r\xe4ttigheterna, den enskilda m\xe4nniskans v\xe4rdighet och v\xe4rde samt m\xe4nnens och kvinnornas lika r\xe4ttigheter, \xe4vensom beslutat fr\xe4mja socialt fram\xe5tskridande och b\xe4ttre levnadsvillkor under st\xf6rre frihet,

en\xe4r medlemsstaterna \xe5tagit sig att i samverkan med F\xf6renta Nationerna s\xe4kerst\xe4lla allm\xe4n och effektiv respekt f\xf6r de m\xe4nskliga r\xe4ttigheterna och de grundl\xe4ggande friheterna,

en\xe4r en gemensam uppfattning av dessa fri- och r\xe4ttigheters inneb\xf6rd \xe4r av st\xf6rsta betydelse f\xf6r uppfyllandet av detta \xe5tagande,`;
$ef3f7060d4e491a2$exports = {
    name: "Swedish",
    udhrPreamble: $ef3f7060d4e491a2$var$udhrPreamble,
    udhr1: $ef3f7060d4e491a2$var$udhr1,
    lang: 'sv'
};


var $a004da7f62cd2820$exports = {};
const $a004da7f62cd2820$var$udhrPreamble = `

Forsameikle as kenning for the inherent dignity and for the richts, equal and nane-alienable, o aw members o the human faimily is the foond o freedom, justice and peace in the warld,

Forsameikle as misregaird and contemption for human richts hes resultit in barbour acts that hes scunnert the conscience o mankind, and the advent o a warld whaur aw human sowels enjoys freedom o thocht and speech, and quittance frae dearth and dreid hes been proclaimed the tapmaist aspiration o the commonty,

Forsameikle as it is necessar, gin man be no gart tak recourse tae rebellion as a hinmaist resort conter tirannie and dounhaudenment, that human richts shuld be beildit by the rule o law,

Forsameikle as it is necessar tae gar freendly relations atween nations aye win forrit,

Forsameikle as the peoples o the Unitit Nations hes in the Chairter affirmit aince mair their faith in fundamental human richts, in the dignity and worth o the human person and in the equal richts o men and wemen and hes resolved tae promote social progress and better standarts o life in braider freedom,

Forsameikle as Member States hes gien their hecht tae win, in compluterance wi the Unitit Nations, the promotion o universal tent and respect for human richts and fundamental freedoms,

Forsameikle as a common understaunding o thir richts and freedoms is o the greatest importance for the ful kenning o this hecht,

Nou, syne,
The General Assemlie

Proclaims this Universal Declaration o Human Richts as a common standart o achievement for aw peoples and aw nations, tae the end that ilka individual and ilka organ o society, aye haudan in mind this Declaration, shal ettle throu teaching and lear tae promote respect for thir richts and freedoms and throu progressive meisures, national and international, mak sover their universal and effective kenning and tenting, baith amang the folk o the Member States theirsels and amang the folk o territours in ower their jurisdiction.`;
const $a004da7f62cd2820$var$udhr1 = `Aw human sowels is born free and equal in dignity and richts. They are tochered wi mense and conscience and shuld guide theirsels ane til ither in a speirit o britherheid.`;
$a004da7f62cd2820$exports = {
    name: "Scots",
    udhrPreamble: $a004da7f62cd2820$var$udhrPreamble,
    udhr1: $a004da7f62cd2820$var$udhr1,
    lang: 'sco'
};


var $539b0354c41f39a0$exports = {};
const $539b0354c41f39a0$var$udhrPreamble = `
\u{644}\u{645}\u{627} \u{643}\u{627}\u{646} \u{627}\u{644}\u{627}\u{639}\u{62A}\u{631}\u{627}\u{641} \u{628}\u{627}\u{644}\u{643}\u{631}\u{627}\u{645}\u{629} \u{627}\u{644}\u{645}\u{62A}\u{623}\u{635}\u{644}\u{629} \u{641}\u{64A} \u{62C}\u{645}\u{64A}\u{639} \u{623}\u{639}\u{636}\u{627}\u{621} \u{627}\u{644}\u{623}\u{633}\u{631}\u{629} \u{627}\u{644}\u{628}\u{634}\u{631}\u{64A}\u{629} \u{648}\u{628}\u{62D}\u{642}\u{648}\u{642}\u{647}\u{645} \u{627}\u{644}\u{645}\u{62A}\u{633}\u{627}\u{648}\u{64A}\u{629} \u{627}\u{644}\u{62B}\u{627}\u{628}\u{62A}\u{629} \u{647}\u{648} \u{623}\u{633}\u{627}\u{633} \u{627}\u{644}\u{62D}\u{631}\u{64A}\u{629} \u{648}\u{627}\u{644}\u{639}\u{62F}\u{644} \u{648}\u{627}\u{644}\u{633}\u{644}\u{627}\u{645} \u{641}\u{64A} \u{627}\u{644}\u{639}\u{627}\u{644}\u{645}\u{60C}

\u{641}\u{64A} \u{62D}\u{64A}\u{646} \u{623}\u{646} \u{62A}\u{646}\u{627}\u{633}\u{64A} \u{62D}\u{642}\u{648}\u{642} \u{627}\u{644}\u{625}\u{646}\u{633}\u{627}\u{646} \u{642}\u{62F} \u{623}\u{62F}\u{649} \u{625}\u{644}\u{649} \u{623}\u{639}\u{645}\u{627}\u{644} \u{647}\u{645}\u{62C}\u{64A}\u{629} \u{623}\u{62B}\u{627}\u{631}\u{62A} \u{63A}\u{636}\u{628} \u{636}\u{645}\u{64A}\u{631} \u{627}\u{644}\u{628}\u{634}\u{631}\u{64A}\u{629}\u{60C} \u{648}\u{638}\u{647}\u{648}\u{631} \u{639}\u{627}\u{644}\u{645} \u{64A}\u{62A}\u{645}\u{62A}\u{639} \u{641}\u{64A}\u{647} \u{627}\u{644}\u{628}\u{634}\u{631} \u{628}\u{62D}\u{631}\u{64A}\u{629} \u{627}\u{644}\u{643}\u{644}\u{627}\u{645} \u{648}\u{627}\u{644}\u{645}\u{639}\u{62A}\u{642}\u{62F} \u{648}\u{627}\u{644}\u{62A}\u{62D}\u{631}\u{631} \u{645}\u{646} \u{627}\u{644}\u{62E}\u{648}\u{641} \u{648}\u{627}\u{644}\u{639}\u{648}\u{632} \u{642}\u{62F} \u{623}\u{639}\u{644}\u{646} \u{623}\u{646}\u{647} \u{623}\u{639}\u{644}\u{649} \u{62A}\u{637}\u{644}\u{639}\u{627}\u{62A} \u{645}\u{646} \u{639}\u{627}\u{645}\u{629} \u{627}\u{644}\u{646}\u{627}\u{633}\u{60C}

\u{648}\u{644}\u{645}\u{627} \u{643}\u{627}\u{646} \u{645}\u{646} \u{627}\u{644}\u{636}\u{631}\u{648}\u{631}\u{64A} \u{623}\u{646} \u{64A}\u{62A}\u{648}\u{644}\u{649} \u{627}\u{644}\u{642}\u{627}\u{646}\u{648}\u{646} \u{62D}\u{645}\u{627}\u{64A}\u{629} \u{62D}\u{642}\u{648}\u{642} \u{627}\u{644}\u{625}\u{646}\u{633}\u{627}\u{646} \u{644}\u{643}\u{64A}\u{644}\u{627} \u{64A}\u{636}\u{637}\u{631} \u{627}\u{644}\u{645}\u{631}\u{621} \u{622}\u{62E}\u{631} \u{627}\u{644}\u{623}\u{645}\u{631} \u{625}\u{644}\u{649} \u{627}\u{644}\u{62A}\u{645}\u{631}\u{62F} \u{639}\u{644}\u{649} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{62F}\u{627}\u{62F} \u{648}\u{627}\u{644}\u{638}\u{644}\u{645}\u{60C}

\u{648}\u{644}\u{645}\u{627} \u{643}\u{627}\u{646} \u{645}\u{646} \u{627}\u{644}\u{62C}\u{648}\u{647}\u{631}\u{64A} \u{62A}\u{639}\u{632}\u{64A}\u{632} \u{62A}\u{646}\u{645}\u{64A}\u{629} \u{627}\u{644}\u{639}\u{644}\u{627}\u{642}\u{627}\u{62A} \u{627}\u{644}\u{648}\u{62F}\u{64A}\u{629} \u{628}\u{64A}\u{646} \u{627}\u{644}\u{62F}\u{648}\u{644}\u{60C}

\u{648}\u{644}\u{645}\u{627} \u{643}\u{627}\u{646}\u{62A} \u{634}\u{639}\u{648}\u{628} \u{627}\u{644}\u{623}\u{645}\u{645} \u{627}\u{644}\u{645}\u{62A}\u{62D}\u{62F}\u{629} \u{642}\u{62F} \u{623}\u{643}\u{62F}\u{62A} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{64A}\u{62B}\u{627}\u{642} \u{645}\u{646} \u{62C}\u{62F}\u{64A}\u{62F} \u{625}\u{64A}\u{645}\u{627}\u{646}\u{647}\u{627} \u{628}\u{62D}\u{642}\u{648}\u{642} \u{627}\u{644}\u{625}\u{646}\u{633}\u{627}\u{646} \u{627}\u{644}\u{623}\u{633}\u{627}\u{633}\u{64A}\u{629} \u{648}\u{628}\u{643}\u{631}\u{627}\u{645}\u{629} \u{627}\u{644}\u{641}\u{631}\u{62F} \u{648}\u{642}\u{62F}\u{631}\u{647} \u{648}\u{628}\u{645}\u{627} \u{644}\u{644}\u{631}\u{62C}\u{627}\u{644} \u{648}\u{627}\u{644}\u{646}\u{633}\u{627}\u{621} \u{645}\u{646} \u{62D}\u{642}\u{648}\u{642} \u{645}\u{62A}\u{633}\u{627}\u{648}\u{64A}\u{629} \u{648}\u{62D}\u{632}\u{645}\u{62A} \u{623}\u{645}\u{631}\u{647}\u{627} \u{639}\u{644}\u{649} \u{623}\u{646} \u{62A}\u{62F}\u{641}\u{639} \u{628}\u{627}\u{644}\u{631}\u{642}\u{64A} \u{627}\u{644}\u{627}\u{62C}\u{62A}\u{645}\u{627}\u{639}\u{64A} \u{642}\u{62F}\u{645}\u{627}\u{64B} \u{648}\u{623}\u{646} \u{62A}\u{631}\u{641}\u{639} \u{645}\u{633}\u{62A}\u{648}\u{649} \u{627}\u{644}\u{62D}\u{64A}\u{627}\u{629} \u{641}\u{64A} \u{62C}\u{648} \u{645}\u{646} \u{627}\u{644}\u{62D}\u{631}\u{64A}\u{629} \u{623}\u{641}\u{633}\u{62D}\u{60C}

\u{648}\u{644}\u{645}\u{627} \u{643}\u{627}\u{646}\u{62A} \u{627}\u{644}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{623}\u{639}\u{636}\u{627}\u{621} \u{642}\u{62F} \u{62A}\u{639}\u{647}\u{62F}\u{62A} \u{628}\u{627}\u{644}\u{62A}\u{639}\u{627}\u{648}\u{646} \u{645}\u{639} \u{627}\u{644}\u{623}\u{645}\u{645} \u{627}\u{644}\u{645}\u{62A}\u{62D}\u{62F}\u{629} \u{639}\u{644}\u{649} \u{636}\u{645}\u{627}\u{646} \u{627}\u{637}\u{631}\u{627}\u{62F} \u{645}\u{631}\u{627}\u{639}\u{627}\u{629} \u{62D}\u{642}\u{648}\u{642} \u{627}\u{644}\u{625}\u{646}\u{633}\u{627}\u{646} \u{648}\u{627}\u{644}\u{62D}\u{631}\u{64A}\u{627}\u{62A} \u{627}\u{644}\u{623}\u{633}\u{627}\u{633}\u{64A}\u{629} \u{648}\u{627}\u{62D}\u{62A}\u{631}\u{627}\u{645}\u{647}\u{627}\u{60C}

\u{648}\u{644}\u{645}\u{627} \u{643}\u{627}\u{646} \u{644}\u{644}\u{625}\u{62F}\u{631}\u{627}\u{643} \u{627}\u{644}\u{639}\u{627}\u{645} \u{644}\u{647}\u{630}\u{647} \u{627}\u{644}\u{62D}\u{642}\u{648}\u{642} \u{648}\u{627}\u{644}\u{62D}\u{631}\u{64A}\u{627}\u{62A} \u{627}\u{644}\u{623}\u{647}\u{645}\u{64A}\u{629} \u{627}\u{644}\u{643}\u{628}\u{631}\u{649} \u{644}\u{644}\u{648}\u{641}\u{627}\u{621} \u{627}\u{644}\u{62A}\u{627}\u{645} \u{628}\u{647}\u{630}\u{627} \u{627}\u{644}\u{62A}\u{639}\u{647}\u{62F}\u{60C}

\u{641}\u{627}\u{644}\u{622}\u{646}\u{60C}

\u{627}\u{644}\u{62C}\u{645}\u{639}\u{64A}\u{629} \u{627}\u{644}\u{639}\u{627}\u{645}\u{629}\u{60C}

\u{62A}\u{646}\u{627}\u{62F}\u{64A} \u{628}\u{647}\u{630}\u{627} \u{627}\u{644}\u{625}\u{639}\u{644}\u{627}\u{646} \u{627}\u{644}\u{639}\u{627}\u{644}\u{645}\u{64A} \u{644}\u{62D}\u{642}\u{648}\u{642} \u{627}\u{644}\u{625}\u{646}\u{633}\u{627}\u{646} \u{639}\u{644}\u{649} \u{623}\u{646}\u{647} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{648}\u{649} \u{627}\u{644}\u{645}\u{634}\u{62A}\u{631}\u{643} \u{627}\u{644}\u{630}\u{64A} \u{64A}\u{646}\u{628}\u{63A}\u{64A} \u{623}\u{646} \u{62A}\u{633}\u{62A}\u{647}\u{62F}\u{641}\u{647} \u{643}\u{627}\u{641}\u{629} \u{627}\u{644}\u{634}\u{639}\u{648}\u{628} \u{648}\u{627}\u{644}\u{623}\u{645}\u{645} \u{62D}\u{62A}\u{649} \u{64A}\u{633}\u{639}\u{649} \u{643}\u{644} \u{641}\u{631}\u{62F} \u{648}\u{647}\u{64A}\u{626}\u{629} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{62C}\u{62A}\u{645}\u{639}\u{60C} \u{648}\u{627}\u{636}\u{639}\u{64A}\u{646} \u{639}\u{644}\u{649} \u{627}\u{644}\u{62F}\u{648}\u{627}\u{645} \u{647}\u{630}\u{627} \u{627}\u{644}\u{625}\u{639}\u{644}\u{627}\u{646} \u{646}\u{635}\u{628} \u{623}\u{639}\u{64A}\u{646}\u{647}\u{645}\u{60C} \u{625}\u{644}\u{649} \u{62A}\u{648}\u{637}\u{64A}\u{62F} \u{627}\u{62D}\u{62A}\u{631}\u{627}\u{645} \u{647}\u{630}\u{647} \u{627}\u{644}\u{62D}\u{642}\u{648}\u{642} \u{648}\u{627}\u{644}\u{62D}\u{631}\u{64A}\u{627}\u{62A} \u{639}\u{646} \u{637}\u{631}\u{64A}\u{642} \u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{645} \u{648}\u{627}\u{644}\u{62A}\u{631}\u{628}\u{64A}\u{629} \u{648}\u{627}\u{62A}\u{62E}\u{627}\u{630} \u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A} \u{645}\u{637}\u{631}\u{62F}\u{629}\u{60C} \u{642}\u{648}\u{645}\u{64A}\u{629} \u{648}\u{639}\u{627}\u{644}\u{645}\u{64A}\u{629}\u{60C} \u{644}\u{636}\u{645}\u{627}\u{646} \u{627}\u{644}\u{627}\u{639}\u{62A}\u{631}\u{627}\u{641} \u{628}\u{647}\u{627} \u{648}\u{645}\u{631}\u{627}\u{639}\u{627}\u{62A}\u{647}\u{627} \u{628}\u{635}\u{648}\u{631}\u{629} \u{639}\u{627}\u{644}\u{645}\u{64A}\u{629} \u{641}\u{639}\u{627}\u{644}\u{629} \u{628}\u{64A}\u{646} \u{627}\u{644}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{623}\u{639}\u{636}\u{627}\u{621} \u{630}\u{627}\u{62A}\u{647}\u{627} \u{648}\u{634}\u{639}\u{648}\u{628} \u{627}\u{644}\u{628}\u{642}\u{627}\u{639} \u{627}\u{644}\u{62E}\u{627}\u{636}\u{639}\u{629} \u{644}\u{633}\u{644}\u{637}\u{627}\u{62A}\u{647}\u{627}.
`;
const $539b0354c41f39a0$var$udhr1 = `\u{64A}\u{648}\u{644}\u{62F} \u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{646}\u{627}\u{633} \u{623}\u{62D}\u{631}\u{627}\u{631}\u{627}\u{64B} \u{648}\u{645}\u{62A}\u{633}\u{627}\u{648}\u{64A}\u{646} \u{641}\u{64A} \u{627}\u{644}\u{643}\u{631}\u{627}\u{645}\u{629} \u{648}\u{627}\u{644}\u{62D}\u{642}\u{648}\u{642}. \u{648}\u{647}\u{645} \u{642}\u{62F} \u{648}\u{647}\u{628}\u{648}\u{627} \u{627}\u{644}\u{639}\u{642}\u{644} \u{648}\u{627}\u{644}\u{648}\u{62C}\u{62F}\u{627}\u{646} \u{648}\u{639}\u{644}\u{64A}\u{647}\u{645} \u{623}\u{646} \u{64A}\u{639}\u{627}\u{645}\u{644}\u{648}\u{627} \u{628}\u{639}\u{636}\u{647}\u{645} \u{628}\u{639}\u{636}\u{627}\u{64B} \u{628}\u{631}\u{648}\u{62D} \u{627}\u{644}\u{625}\u{62E}\u{627}\u{621}.`;
$539b0354c41f39a0$exports = {
    name: "Arabic",
    udhrPreamble: $539b0354c41f39a0$var$udhrPreamble,
    udhr1: $539b0354c41f39a0$var$udhr1,
    direction: 'rtl',
    lang: 'ar'
};


var $dfb3df29c2a49a04$exports = {};
const $dfb3df29c2a49a04$var$udhrPreamble = `Considerant que de recon\xe9isser la dignitat inerenta a totes los membres de la familha umana e lors dreches egals e inalienables constitu\xeds lo fondament de la libertat, de la just\xedcia e de la patz dins lo mond,

Considerant que de descon\xe9isser e mespresar los dreches de l'\xf2me a menat a de barbaritats otrajantas per la consci\xe9ncia de l'umanitat e que l'aveniment d'un mond ont los \xe8ssers umans ser\xe0n liures de parlar e de creire, deliurats de la terror e de la mis\xe8ria, es estat proclamat coma l'aspiracion mai nauta de l'\xf2me,

Considerant qu'es essencial que los dreches de l'\xf2me si\xe0n aparats per un regime de drech per tal que l'\xf2me si\xe1 pas obligat al supr\xe8me recors de se revoltar contra la tirania e l'opression,

Considerant qu'es essencial d'encoratjar lo desvolopament de relacions amicalas entre las nacions,

Considerant que, dins la Carta, los p\xf2bles de las Nacions Unidas an tornat proclamar lor fe dins los dreches fondamentals de l'\xf2me, dins la dignitat e la valor de la persona umana, dins l'egalitat dels dreches dels \xf2mes e de las femnas, e que se son declarats resolguts a favorir lo progr\xe8s social e a instaurar de melhoras condicions de vida dins una libertat mai b\xe8la,

Considerant que los Estats Membres se son engatjats a assegurar, en cooperacion amb l'Organisacion de las Nacions Unidas, lo respecte universal e efectiu dels dreches de l'\xf2me e de las libertats fondamentalas,

Considerant qu'una concepcion comuna d'aqueles dreches e libertats es de la m\xe0ger import\xe0ncia per que se realise plenament aquel engatjament,

l'Assemblada Generala proclama

la presenta Declaracion Universala dels Dreches de l'\xf2me

coma l'ideal comun que totes los p\xf2bles e las Nacions devon cercar a at\xe9nher, per tal que totes los individ\xfas e totas las institucions, en gardant de contunh aicesta Declaracion presenta a l'esperit s'ef\xf2rcen, per l'ensenhament e l'educacion, de desvolopar lo resp\xe8cte d'aqueles dreches e libertats e d'assegurar, per de mesuras progressivas d'\xf2rdre nacional e internacional, la reconeissen\xe7a e l'aplicacion universalas e efectivas, tant demest los p\xf2bles dels Estats Membres coma demest los dels territ\xf2ris pla\xe7ats jos lor jurisdiccion.

`;
const $dfb3df29c2a49a04$var$udhr1 = `Totes los \xe8ssers umans naisson liures e egals en dignitat e en dreches. Son dotats de rason e de consci\xe9ncia e se devon comportar los unes amb los autres dins un esperit de fraternitat.`;
$dfb3df29c2a49a04$exports = {
    name: "Occitan",
    udhrPreamble: $dfb3df29c2a49a04$var$udhrPreamble,
    udhr1: $dfb3df29c2a49a04$var$udhr1,
    lang: 'oc'
};


var $49b674eaa3ebfb79$exports = {};
const $49b674eaa3ebfb79$var$udhrPreamble = `A liberdade, a xustiza e a paz no mundo te\xf1en por base o reco\xf1ecemento da dignidade intr\xednseca e dos dereitos iguais e inalienables de t\xf3dolos membros da familia humana;

O desco\xf1ecemento e o menosprezo dos dereitos da persoa orixinaron actos de barbarie aldraxantes para a conciencia da humanidade; proclamouse, como a aspiraci\xf3n m\xe1is elevada da persoa, o advento dun mundo no que os seres humanos, liberados do temor e da miseria, disfruten da liberdade de palabra e da liberdade de crenzas;

Esencial que os dereitos da persoa sexan protexidos por un r\xedxime de dereito, co fin de que a persoa non se vexa compelida \xf3 supremo recurso da rebeli\xf3n contra a tiran\xeda e a opresi\xf3n;

Tam\xe9n esencial promover o desenvolvemento de relaci\xf3ns amigables entre as naci\xf3ns;

Os pobos das Naci\xf3ns Unidas reafirmaron na Carta a s\xfaa fe nos dereitos fundamentais da persoa, na dignidade e o valor do ser humano e na igualdade de dereitos de homes e mulleres; declar\xe1ronse resoltos a promover o progreso social e a elevar o nivel de vida dentro dun concepto m\xe1is amplo de liberdade;

Os estados membros compromet\xedronse a asegurar, en cooperaci\xf3n coa Organizaci\xf3n das Naci\xf3ns Unidas, o respecto universal e efectivo \xf3s dereitos e liberdades fundamentais da persoa; e

Unha concepci\xf3n com\xfan destes dereitos e liberdades \xf3 da maior importancia para o pleno cumprimento de dito compromiso;

A Asemblea Xeral proclama a presente Declaraci\xf3n Universal dos Dereitos da Persoa como ideal com\xfan polo que t\xf3dolos pobos e naci\xf3ns se deben esforzar, para que tanto os individuos coma as instituci\xf3ns, inspir\xe1ndose constantemente nela, promovan, mediante o ensino e a educaci\xf3n, o respecto a estes dereitos e liberdades, e aseguren, por medidas progresivas de car\xe1cter nacional e internacional, o seu reco\xf1ecemento e aplicaci\xf3n universais e efectivos, tanto entre os pobos dos estados membros coma entre os dos territorios colocados baixo a s\xfaa xurisdicci\xf3n.
`;
const $49b674eaa3ebfb79$var$udhr1 = `T\xf3dolos seres humanos nacen libres e iguais en dignidade e dereitos e, dotados como est\xe1n de raz\xf3n e conciencia, d\xedbense comportar fraternalmente uns cos outros.`;
$49b674eaa3ebfb79$exports = {
    name: "Galician",
    udhrPreamble: $49b674eaa3ebfb79$var$udhrPreamble,
    udhr1: $49b674eaa3ebfb79$var$udhr1,
    lang: 'gl'
};


var $c740205882603bf6$exports = {};
const $c740205882603bf6$var$udhrPreamble = `Cunsidarendu ch'ellu ci voli \xe0 ricunnoscia a dignit\xe0 propria di tutti i membri di a famiglia umana \xe8 i so diritti pari ed inalienabili par ch'elli sianu fundati a libert\xe0, a ghjustizia \xe8 a paci ind'u mondu,

Cunsidarendu ch\xec, \xf9n cunniscendu o sprizzendu i diritti di l'omu, si h\xe8 ghjuntu \xe0 atti barbari ch\xec a cuscenza umana ni h\xe8 rivultata, \xe8 ch'ella h\xe8 stata chjamata a spiranza pi\xf9 alta di l'omu quilla di f\xe0 nascia un mondu duva elli saranu libari l'omi di parl\xe0 \xe8 di creda, libarati da u tarrori \xe8 da e miseria,

Cunsidarendu ch'ella h\xe8 una primura mai\xf2 ch'elli sianu prutetti i diritti di l'omu da un guvernu di dirittu, da ch'ellu \xf9n sia custrettu l'omu, ghjuntu \xe0 i punti stremi, \xe0 rivult\xe0 si contru \xe0 a tirannia \xe8 l'upprissioni,

Cunsidarendu ch'ella h\xe8 una primura mai\xf2 di f\xe0 ch'elli si sviloppinu i leii amichevuli tr\xe0 i nazioni,

Cunsidarendu ch'elli anu dittu in lu so Statutu i populi di i Nazioni Uniti ch'elli credinu in li diritti fundamintali di l'omu, in la dignit\xe0 \xe8 u valori di a parsona umana, in la parit\xe0 di i diritti di l' omi \xe8 di i donni, \xe8 ch'elli anu dittu d'essa dicisi \xe0 svilupp\xe0 u prugressu suciali \xe8 \xe0 f\xe0 nascia un modu di camp\xe0 pi\xf9 bonu ind'una libert\xe0 pi\xf9 mai\xf2,

Cunsidarendu ch'elli anu prumissu i Stati Membri di f\xe0, c\xf9 l'aiutu di l'Urganisazioni di i Nazioni Uniti, ch'elli sianu rispittati da veru in lu mondu sanu i diritti di l'omu \xe8 i libert\xe0 fundamintali,

Cunsidarendu ch\xec par rializ\xe0 isssa prumessa, h\xe8 di primura d'av\xe8 una idea cumuna d'issi diritti \xe8 libert\xe0,

Sta Dichjarazioni Univirsali di i Diritti di l'Omu

cum'\xe8 fini cumunu da ricirc\xe0 da tutti i populi \xe8 tutti i nazioni, par ch'elli provinu tutti l'individui \xe8 tutti l'urganisazioni di a sucit\xe0, c\xf9 u insignamentu \xe8 l'educazioni, \xe0 svilupp\xe0 u rispettu d'issi diritti, \xe8, pigliendu \xe0 pocu \xe0 pocu i misuri naziunali \xe8 internaziunali, \xe0 impona ni ignalocu a ricunniscenza \xe8 a prattica vera, sia ind'\xe8 i populi di i Stati membri stesi, sia ind'\xe8 quilli di i tarritorii ad elli cunfidati.`;
const $c740205882603bf6$var$udhr1 = `Nascinu tutti l'omi libari \xe8 pari di dignit\xe0 \xe8 di diritti. Pussedinu a raghjoni \xe8 a cuscenza \xe8 li tocca ad agiscia tr\xe0 elli di modu fraternu.`;
$c740205882603bf6$exports = {
    name: "Corsican",
    udhrPreamble: $c740205882603bf6$var$udhrPreamble,
    udhr1: $c740205882603bf6$var$udhr1,
    lang: 'co'
};


var $bee4c665731cc063$exports = {};
const $bee4c665731cc063$var$udhrPreamble = `Da anerkendelse af den mennesket iboende v\xe6rdighed og af de lige og ufortabelige rettigheder for alle medlemmer af den menneskelige familie er grundlaget for frihed, retf\xe6rdighed og fred i verden,

da tilsides\xe6ttelse af og foragt for menneskerettighederne har f\xf8rt til barbariske handlinger, der har opr\xf8rt menneskehedens samvittighed, og da skabelsen af en verden, hvor menneskene nyder tale- og trosfrihed og frihed for frygt og n\xf8d, er blevet forkyndt som folkenes h\xf8jeste m\xe5l,

da det er af afg\xf8rende betydning, at menneskerettighederne beskyttes af loven, hvis ikke mennesket som en sidste udvej skal tvinges til at g\xf8re opr\xf8r mod tyranni og undertrykkelse,

da det er af afg\xf8rende betydning at fremme udviklingen af venskabelige forhold mellem nationerne,

da De forenede Nationers folk i pagten p\xe5ny har bekr\xe6ftet deres tro p\xe5 fundamentale menneskerettigheder, p\xe5 menneskets v\xe6rdighed og v\xe6rd og p\xe5 lige rettigheder for m\xe6nd og kvinder, og har besluttet at fremme sociale fremskridt og h\xf8jne levevilk\xe5rene under st\xf8rre frihed,

da medlemsstaterne har forpligtet sig til i samarbejde med De forenede Nationer at arbejde for fremme af almindelig respekt fur og overholdelse af menneskerettigheder og fundamentale frihedsrettigheder,

da en f\xe6lles forst\xe5else af disse rettigheder og friheder er af den st\xf8rste betydning for den fulde virkeligg\xf8relse af denne forpligtelse,

proklamerer

PLENARFORSAMLINGEN

derfor nu denne VERDENSERKL\xc6RING OM MENNESKERETTIGHEDERNE som et f\xe6lles m\xe5l for alle folk og alle nationer med det form\xe5l, at ethvert menneske og ethvert samfundsorgan stedse med denne erkl\xe6ring for \xf8je skal str\xe6be efter gennem undervisning og opdragelse at fremme respekt for disse rettigheder og friheder og gennem fremadskridende nationale og internationale foranstaltninger at sikre, at de anerkendes og overholdes overalt og effektivt, b\xe5de blandt befolkningerne i medlemsstaterne og blandt befolkningerne i de omr\xe5der, der befinder sig under deres styre.`;
const $bee4c665731cc063$var$udhr1 = `Alle mennesker er f\xf8dt frie og lige i v\xe6rdighed og rettigheder. De er udstyret med fornuft og samvittighed, og de b\xf8r handle mod hverandre i en broderskabets \xe5nd.`;
$bee4c665731cc063$exports = {
    name: "Danish",
    udhrPreamble: $bee4c665731cc063$var$udhrPreamble,
    udhr1: $bee4c665731cc063$var$udhr1,
    lang: 'da'
};


var $6cbaf29dbc3dffe3$exports = {};
const $6cbaf29dbc3dffe3$var$udhrPreamble = `Rakger
O veza\xf1 ma'z eo war anaout an dellezegezh enstag ouzh holl izili an denelezh hag o gwirio\xf9 par ha diwerzhus eo diazezet ar frankiz, ar reizhded hag ar peoc'h,

 o veza\xf1 ma'z eo war dizanaout ha dismega\xf1si\xf1 gwirio\xf9 mab-den eo bet ganet an akto\xf9 a varbariezh a sav koustia\xf1s mab-den en o enep, ha ma'z eo bet embannet eo donedigezh ur bed a vo enna\xf1 gant an dud frankiz da gomz ha da gredi\xf1, dieubet ma vint diouzh ar spont hag an dienez, a zo mennad uhela\xf1 mab-den,

o veza\xf1 ma'z eo ret-holl diwall gwirio\xf9 mabden gant reolenn al lezenn evit na vefe ket rediet an dud d'en em sevel ouzh an tirantegezh hag ar gwaskerezh da rekour diwezha\xf1,

o veza\xf1 ma'z eo ret-holl kas war-raok an darempredo\xf9 a vignoniezh etre ar broado\xf9,

o veza\xf1 ma'z eo bet embannet adarre er Garta gant poblo\xf9 ar Broado\xf9-Unanet o feiz e gwirio\xf9 diazez mab-den, e dellezegezh ha talvoudegezh mab-den, e parded ar baotred hag ar merc'hed en o gwirio\xf9, ha ma'z eo bet diskl\xeariet ganto e oant mennet da gas war-raok an diorroadur kevredigezhel ha da wellaat an aozio\xf9-buhez en ur frankiz vrasoc'h,

o veza\xf1 ma'z eo bet gouestlet gant ar Stado\xf9-Ezel diogeli\xf1, gant kenlabour Aozadur ar Broado\xf9-Unanet, an douja\xf1s hollvedel ha gwirion ouzh gwirio\xf9 mab-den hag ar frankizio\xf9 pennan,

hago veza\xf1 ma'z eo a bouez bras kengompren ar gwirio\xf9 hag ar frankizio\xf9-ma\xf1 a-benn seveni\xf1 ar gouestl,

evel uhelvennad boutin da veza\xf1 diraezet gant an holl boblo\xf9 hag an holl vroado\xf9, d'an holl dud hag ensavadurio\xf9, gant an Diskl\xeariadur-ma\xf1 atav en o freder, da lakaat kreski\xf1 dre ar c'helenn hag an deskadurezh, an doujans ouzh ar gwirio\xf9 ha frankizio\xf9-ma\xf1, d'o lakaat da veza\xf1 anavezet ha sevenet tamm-ha-tamm da vat hag e pep lec'h, dre ziarbenno\xf9 broadel hag etrevroadel, koulz e-touez poblo\xf9 ar Stado\xf9-Ezel hag e-touez ar re zo war zouaro\xf9 dindan o lezenno\xf9.

EZ EMBANN
AR VODADEG-VEUR
DISKLERIADUR HOLLVEDEL GWIRIO\xd9 MABDEN`;
const $6cbaf29dbc3dffe3$var$udhr1 = `Dieub ha par en o dellezegezh hag o gwirio\xf9 eo ganet an holl dud. Poell ha skiant zo dezho ha dleout a reont beva\xf1 an eil gant egile en ur spered a genvreudeuriezh.`;
$6cbaf29dbc3dffe3$exports = {
    name: "Breton",
    udhrPreamble: $6cbaf29dbc3dffe3$var$udhrPreamble,
    udhr1: $6cbaf29dbc3dffe3$var$udhr1,
    lang: 'br'
};


$23dedab6f5f098a6$exports = new Set([
    $d8df8c5579faf259$exports,
    $e1fa0f909afcd87e$exports,
    $a48f664eeae2df4c$exports,
    $fca0f2ca02b77145$exports,
    $ef3f7060d4e491a2$exports,
    $28df12e0840324f3$exports,
    $9561357437e49161$exports,
    $5063d38873003c4f$exports,
    $671705ea166718db$exports,
    $dfb3df29c2a49a04$exports,
    $49b674eaa3ebfb79$exports,
    $c740205882603bf6$exports,
    $989a203e15c65038$exports,
    $bee4c665731cc063$exports,
    $cba6a8b5be479746$exports,
    $3b2c81a607797575$exports,
    $146de1b6e4d4d37f$exports,
    $c80287a21426ac92$exports,
    $a004da7f62cd2820$exports,
    $79906511ebf25517$exports,
    $539b0354c41f39a0$exports,
    $6cbaf29dbc3dffe3$exports
]);


/**
 * takes a map of samples and creates a map of ngram objects
 *
 * @param {Map<string, string>} sampleMap collection of samples
 * @param {NGrammer} NGrammer the ngrammer instance
 * @returns {Map<string,NGrammer>} a map of ngram objects
 */ function $a79753e3de1a71aa$var$generateNgramsFromSamples(sampleMap, NGrammer) {
    const ngrams = new Map();
    sampleMap.forEach((sample, language)=>{
        const ngrammer = new NGrammer(sample);
        ngrams.set(language, ngrammer);
    });
    return ngrams;
}
function $a79753e3de1a71aa$var$sortSamplesByName(set) {
    const sortedArray = [
        ...set
    ].sort((a, b)=>{
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    });
    const sortedSet = new Set([
        ...sortedArray
    ]);
    return sortedSet;
}
function $a79753e3de1a71aa$var$createMapFromSet(set, sampleName) {
    const sortedSet = $a79753e3de1a71aa$var$sortSamplesByName(set);
    const map = new Map();
    sortedSet.forEach((sample)=>{
        map.set(sample.name, sample[sampleName]);
    });
    return map;
}
// create a map of samples with their languages
const $a79753e3de1a71aa$var$sampleMap = $a79753e3de1a71aa$var$createMapFromSet($23dedab6f5f098a6$exports, 'udhrPreamble');
$a79753e3de1a71aa$exports = {
    generateNgramsFromSamples: $a79753e3de1a71aa$var$generateNgramsFromSamples,
    sampleMap: $a79753e3de1a71aa$var$sampleMap
};


class $11d2a92009e7857e$var$LanguageNav extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static{
        this.styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`

        :host {
            grid-area: nav;
            width: 100%;
            height: var(--navHeight);
        } 

        .navContainer {
            height: var(--navHeight);
            width: 100%;
        }
        .navList {
            list-style-type: none;
            font-size: var(--smallTextSize);
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            height: var(--navHeight);
        }
        .navList__link {
            color: var(--baseLinkColor);
            text-decoration: inherit;
            border-bottom: 1px solid transparent;
            transition: inherit;
        }

        .navList__link:hover,
        .navList__link:focus {
            color: var(--baseLinkColorHover);
            border-color: var(--baseLinkColorHover);
            outline: inherit;
        }
    `;
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        <nav class="g-header__nav-container navContainer">
            <ul class="g-header__nav-list navList">
                ${(0, $e41d1b66de65ecc4$export$76d90c956114f2c2)(this.languages, ([languageName])=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                    <li class="navList__item">
                        <a href="#${languageName}--tableSet" class="navList__link">${languageName}</a>
                    </li>
                `)}
            </ul>
        </nav>
        `;
    }
    constructor(...args){
        super(...args), this.languages = (0, $a79753e3de1a71aa$exports.sampleMap);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)({
        type: Map
    })
], $11d2a92009e7857e$var$LanguageNav.prototype, "languages", void 0);
$11d2a92009e7857e$var$LanguageNav = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)('language-nav')
], $11d2a92009e7857e$var$LanguageNav);
var $11d2a92009e7857e$export$2e2bcd8739ae039 = $11d2a92009e7857e$var$LanguageNav;








/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f3bd3fa2e54a33fb$var$s = (i, t)=>{
    var e, o;
    const r = i._$AN;
    if (void 0 === r) return !1;
    for (const i of r)null === (o = (e = i)._$AO) || void 0 === o || o.call(e, t, !1), $f3bd3fa2e54a33fb$var$s(i, t);
    return !0;
}, $f3bd3fa2e54a33fb$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === (null == e ? void 0 : e.size));
}, $f3bd3fa2e54a33fb$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $f3bd3fa2e54a33fb$var$l(t);
    }
};
function $f3bd3fa2e54a33fb$var$n(i) {
    void 0 !== this._$AN ? ($f3bd3fa2e54a33fb$var$o(this), this._$AM = i, $f3bd3fa2e54a33fb$var$r(this)) : this._$AM = i;
}
function $f3bd3fa2e54a33fb$var$h(i, t = !1, e = 0) {
    const r = this._$AH, n = this._$AN;
    if (void 0 !== n && 0 !== n.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$f3bd3fa2e54a33fb$var$s(r[i], !1), $f3bd3fa2e54a33fb$var$o(r[i]);
            else null != r && ($f3bd3fa2e54a33fb$var$s(r, !1), $f3bd3fa2e54a33fb$var$o(r));
        } else $f3bd3fa2e54a33fb$var$s(this, i);
    }
}
const $f3bd3fa2e54a33fb$var$l = (i)=>{
    var t, s, o, r;
    i.type == (0, $3baabda811939da5$export$9ba3b3f20a85bfa).CHILD && (null !== (t = (o = i)._$AP) && void 0 !== t || (o._$AP = $f3bd3fa2e54a33fb$var$h), null !== (s = (r = i)._$AQ) && void 0 !== s || (r._$AQ = $f3bd3fa2e54a33fb$var$n));
};
class $f3bd3fa2e54a33fb$export$7d025501802325e extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $f3bd3fa2e54a33fb$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        var e, r;
        i !== this.isConnected && (this.isConnected = i, i ? null === (e = this.reconnected) || void 0 === e || e.call(this) : null === (r = this.disconnected) || void 0 === r || r.call(this)), t && ($f3bd3fa2e54a33fb$var$s(this, i), $f3bd3fa2e54a33fb$var$o(this));
    }
    setValue(t) {
        if ((0, $ead5767561d7cbc1$export$7f431ad0fff82fd9)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a71e39f8d7120011$export$7d1e3a5e95ceca43 = ()=>new $a71e39f8d7120011$var$o;
class $a71e39f8d7120011$var$o {
}
const $a71e39f8d7120011$var$h = new WeakMap, $a71e39f8d7120011$export$eff4d24c3ff7876e = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $f3bd3fa2e54a33fb$export$7d025501802325e) {
    render(t) {
        return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    update(t, [s]) {
        var e;
        const o = s !== this.G;
        return o && void 0 !== this.G && this.ot(void 0), (o || this.rt !== this.lt) && (this.G = s, this.dt = null === (e = t.options) || void 0 === e ? void 0 : e.host, this.ot(this.lt = t.element)), $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    ot(i) {
        var t;
        if ("function" == typeof this.G) {
            const s = null !== (t = this.dt) && void 0 !== t ? t : globalThis;
            let e = $a71e39f8d7120011$var$h.get(s);
            void 0 === e && (e = new WeakMap, $a71e39f8d7120011$var$h.set(s, e)), void 0 !== e.get(this.G) && this.G.call(this.dt, void 0), e.set(this.G, i), void 0 !== i && this.G.call(this.dt, i);
        } else this.G.value = i;
    }
    get rt() {
        var i, t, s;
        return "function" == typeof this.G ? null === (t = $a71e39f8d7120011$var$h.get(null !== (i = this.dt) && void 0 !== i ? i : globalThis)) || void 0 === t ? void 0 : t.get(this.G) : null === (s = this.G) || void 0 === s ? void 0 : s.value;
    }
    disconnected() {
        this.rt === this.lt && this.ot(void 0);
    }
    reconnected() {
        this.ot(this.lt);
    }
});






class $ecf85bc592ac223d$var$TableSet extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static{
        this.samples = (0, $a79753e3de1a71aa$exports.sampleMap);
    }
    static{
        this.styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
    .tableSet {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 1.618em;
        line-height: var(--baseLineHeight);
        margin: 0 .618rem 0 .618rem; /* Comment-A */
    }

    .tableSet:target {
        outline: 1px solid red;
    }
    .tableSet__header {
        position: sticky;
        top: 0;
        width: 100%;
        background: rgba(255, 255, 255, .9);
    }

    .tableSet__title, 
    .tableSet__resultsHeading,
    summary {
        font-family: var(--titleFontFamily);
        line-height: var(--smallLineHeight);
        border-bottom: 2px solid transparent;
        margin: 0 .618rem 0 .618rem; /* Comment-A */
        margin-bottom: calc(1.618vmin - 1vmax + .35em)
    }
    .tableSet__title {
        font-size: var(--bigTitleSize);
    }

    .tableSet__resultsHeading {
        font-size: var(--smallestTitleSize);
    }

    :host:target {
        outline: 1px solid var(--colorCoolDarker);
    }
    :host:target .tableSet__title {
        border-bottom-color: var(--colorCoolDarker);
    }
    .tableSet__sample {
        font-size: var(--smallestTextSize);
        max-height: 2em;
        margin: .618rem .618rem;
        overflow: hidden;
        transition: .3s ease-in-out;
    }

    .tableSet__sampleEditor {
        width: 98%;
        min-height: 15em;
    }
.tableSet__sample[open] {
    max-height: 50vh;
}

.tableSet__sampleText {
    background: rgba(165, 165, 165, .15);
    border-left: 10px solid var(--colorNeutralLighter);
    margin: 1.618em .618rem; 
    padding: 0.618em .618rem;
    quotes: "\\201C""\\201D""\\2018""\\2019";
    width: 98%;
    min-height: 15em;
}

.tableSet__sampleText::before {
    color: var(--colorNeutralLight);
    content: open-quote;
    font-size: 4em;
    line-height: 0.1em;
    margin-right: 0.25em;
    vertical-align: -0.4em;
}
.tableSet__tables {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 5vw;
    justify-content: space-between;
    width: 100%;
    max-height: 100vh;
    overflow-y: scroll;
    transition: all .3s ease-in-out;
}

.tableSet--collapsed .tableSet__tables {
    max-height: 0em;
    overflow: hidden;
}

.tableSet__controls {
    width: 100%;
    flex-grow:1;
}

.tableSet__helperText {
    display: block;
    font-size: var(--smallestTextSize);
    font-style: var(--alternateFontVoice);
}
mark {
    background-color: rgba(165, 220, 165, .9);
}

::selection {
    background-color: rgba(165, 220, 220, .9);
}

/* Because mark and selection have same saturation, brightenss, mark won't easily stand out if it's selected */
mark::selection {
    background-color: rgba(165, 220, 110, .9);
}

    `;
    }
    constructor(){
        super(), this.direction = 'ltr', this.langId = '', this.languageName = '', this.languageSample = '', this.shouldHighlightWord = false, this.highlightedSample = '', this.tableSize = 10, this.relationTableSize = 5, this.sampleTextareaRef = (0, $a71e39f8d7120011$export$7d1e3a5e95ceca43)(), this.sampleHighlightRef = (0, $a71e39f8d7120011$export$7d1e3a5e95ceca43)();
        this.ngram = new (0, $8660d1d8b4827d96$exports.Methodius)();
        window[this.languageName] = this.ngram;
    }
    getCleanedSample(languageSample = this.languageSample) {
        const sample = languageSample;
        const cleanSample = sample.replaceAll(/<mark>/g, "").replaceAll(/<\/mark>/g, "");
        return cleanSample;
    }
    getHighlightedSample(highlight, shouldHighlightWord = false) {
        const sample = this.languageSample;
        if (!highlight) return sample;
        const cleanSample = this.getCleanedSample(sample);
        const highlightRegex = shouldHighlightWord ? new RegExp(`\\b${highlight}\\b`, 'gi') : new RegExp(`${highlight}`, 'g');
        const highlightedSample = cleanSample.replaceAll(highlightRegex, `<mark>${highlight}</mark>`);
        return highlightedSample;
    }
    willUpdate(changedProperties) {
        if (changedProperties.has('languageName') && !this.languageSample) {
            const langSample = $ecf85bc592ac223d$var$TableSet.samples.get(this.languageName);
            this.languageSample = langSample;
            this.ngram = new (0, $8660d1d8b4827d96$exports.Methodius)(this.getCleanedSample(this.languageSample));
            window[this.languageName] = this.ngram;
            this.highlightedSample = this.languageSample;
        } else if (this.languageSample && changedProperties.has('languageSample')) {
            this.ngram = new (0, $8660d1d8b4827d96$exports.Methodius)(this.getCleanedSample(this.languageSample));
            window[this.languageName] = this.ngram;
            this.highlightedSample = this.getHighlightedSample(this.highlightString, this.shouldHighlightWord);
        }
    }
    cellClickHandler(evt, shouldHighlightWord = false) {
        const target = evt.composedPath()[0];
        console.log(evt);
        if (target.classList.contains('table__col1')) {
            const highlightVal = target.innerText;
            this.highlightString = highlightVal;
            this.shouldHighlightWord = shouldHighlightWord;
            const highlightedSample = this.getHighlightedSample(highlightVal, shouldHighlightWord);
            this.highlightedSample = highlightedSample;
            this.sampleTextareaRef.value.removeAttribute('open');
            this.sampleHighlightRef.value.setAttribute('open', true);
        } else if (evt.shiftKey) {
            const table = evt.target;
            const parentContainer = table.parentNode;
            const allTables = parentContainer.querySelectorAll('frequency-table');
            allTables.forEach((table)=>table.classList.remove('table--focused', 'table-blurred'));
            table.classList.toggle('table--focused');
            const otherTables = parentContainer.querySelectorAll('frequency-table:not(.table--focused)');
            otherTables.forEach((table)=>{
                table.classList.toggle('table--blurred');
            });
        }
    }
    getTopPlacements(topNGrams, placements) {
        const topPlacements = new Map();
        [
            ...topNGrams.entries()
        ].forEach(([bigram])=>{
            topPlacements.set(bigram, placements.get(bigram));
        });
        return topPlacements;
    }
    _sampleUpdate(event) {
        // when someone edits the text, remove highlighting
        this.languageSample = this.getCleanedSample(event.currentTarget.value);
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <article id="${this.languageName}--tableSet" class="tableSet">
                <header class="tableSet__header">
                    <h2 class="tableSet__title">${this.languageName}</h2>
                    <details class="tableSet__sample" ${(0, $a71e39f8d7120011$export$eff4d24c3ff7876e)(this.sampleTextareaRef)}>
                        <summary>Edit sample</summary>
                        <textarea 
                            id="sample-update" 
                            class="tableSet__sampleEditor" 
                            @input="${this._sampleUpdate}"
                            lang="${this.langId}" 
                            .value=${this.languageSample}
                        >
                            ${this.languageSample}>
                        </textarea>
                    </details>
                    <details class="tableSet__sample" ${(0, $a71e39f8d7120011$export$eff4d24c3ff7876e)(this.sampleHighlightRef)}>
                        <summary class="tableSet__sampleHeading">View Sample</summary>
                        <blockquote 
                            lang="${this.langId}"
                            class="js-${this.languageName} tableSet__sampleText" 
                            dir="${this.direction}" 
                            .innerHTML=${this.highlightedSample}
                        >
                        </blockquote>
                    </details>
                </header>
                <details class="tableSet__results">
                <summary class="tableSet__resultsHeading">View Analysis </summary>
                    <div class="tableSet__controls">
                        <label for="tableSize">Table Rows</label>
                        <input id="tableSize" type="number" min="5" max="75" .value=${this.tableSize} @change=${(evt)=>this.tableSize = evt.currentTarget.value}>
                        <small class="tableSet__helperText">click on a letter, bigram, ngram, or word to see it highlighted in the sample.</small>
                    </div>
                <h3>Frequencies</h3>
                <div class="tablesContainer tableSet__tables">
                    <frequency-table
                        direction="${this.direction}"
                        langId="${this.langId}"
                        caption="Most frequent letters out of ${this.ngram.letters.length}" 
                        col1Header="Letter"
                        .frequencies=${this.ngram.getTopLetters(this.tableSize)}
                        @click=${(evt)=>{
            this.cellClickHandler(evt);
        }}>
                    </frequency-table>
                    <frequency-table
                        direction="${this.direction}"
                        langId="${this.langId}"
                        caption="Most frequent bigrams out of ${this.ngram.bigrams.length} " 
                        col1Header="Bigram"
                        .frequencies=${this.ngram.getTopBigrams(this.tableSize)}
                        @click=${(evt)=>{
            this.cellClickHandler(evt);
        }}>
                    </frequency-table>
                    <frequency-table
                        direction="${this.direction}"
                        langId="${this.langId}" 
                        caption="Most frequent trigrams out of ${this.ngram.trigrams.length}" 
                        col1Header="Trigram"
                        .frequencies=${this.ngram.getTopTrigrams(this.tableSize)}
                        @click=${(evt)=>{
            this.cellClickHandler(evt);
        }}>
                    </frequency-table>
                    <frequency-table
                        direction="${this.direction}"
                        langId="${this.langId}" 
                        caption="Most frequent words out of ${this.ngram.words.length}" 
                        col1Header="Word"
                        .frequencies=${this.ngram.getTopWords(this.tableSize)}
                        @click=${(evt)=>{
            this.cellClickHandler(evt, true);
        }}>
                    </frequency-table>
                    </div>
                <h3>Positions</h3>
                <div class="tablesContainer tableSet__tables">
                    <frequency-table
                        direction="${this.direction}"
                        langId="${this.langId}" 
                        caption="Bigram Positions"
                        col1Header="Bigram"
                        col2Header="Positions"
                        .frequencies=${this.getTopPlacements(this.ngram.getTopBigrams(this.tableSize), this.ngram.bigramPositions)}
                        @click=${(evt)=>{
            this.cellClickHandler(evt);
        }}>
                    </frequency-table>
                    <frequency-table
                        direction="${this.direction}"
                        langId="${this.langId}" 
                        caption="Trigram Positions" 
                        col1Header="Trigram"
                        col2Header="Positions"
                        .frequencies=${this.getTopPlacements(this.ngram.getTopTrigrams(this.tableSize), this.ngram.trigramPositions)}
                        @click=${(evt)=>{
            this.cellClickHandler(evt);
        }}>
                    </frequency-table>
                </div>
                <h3>Relationships</h3>
                <div class="tablesContainer tableSet__tables">
                    <div class="tableSet__controls">
                        <label for="tableSize-2">Table Rows</label>
                        <input id="tableSize-2" type="number" min="5" max="75" .value=${this.relationTableSize} @change=${(evt)=>this.relationTableSize = evt.currentTarget.value}>
                    </div>
                    <frequency-table
                        direction="${this.direction}"
                        langId="${this.langId}"
                        caption="Top Bigram relationships"
                        col1Header="Bigram"
                        col2Header="N times occurs with other top bigrams"
                        .frequencies=${this.ngram.getRelatedTopNgrams(2, this.relationTableSize)}
                        @click=${(evt)=>{
            this.cellClickHandler(evt);
        }}>
                        </frequency-table>
                    <frequency-table
                        direction="${this.direction}"
                        langId="${this.langId}"
                        caption="Top trigram relationships"
                        col1Header="trigram"
                        col2Header="N times occurs with other top Trigrams"
                        .frequencies=${this.ngram.getRelatedTopNgrams(3, this.relationTableSize)}
                        @click=${(evt)=>{
            this.cellClickHandler(evt);
        }}>
                        </frequency-table>
                    <frequency-table
                        direction="${this.direction}"
                        langId="${this.langId}"
                        caption="Top 4-gram relationships"
                        col1Header="4gram"
                        col2Header="N times occurs with other top Trigrams"
                        .frequencies=${this.ngram.getRelatedTopNgrams(4, this.relationTableSize)}
                        @click=${(evt)=>{
            this.cellClickHandler(evt);
        }}>
                        </frequency-table>
                </div>
            </details>
            </article>
        `;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $ecf85bc592ac223d$var$TableSet.prototype, "direction", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $ecf85bc592ac223d$var$TableSet.prototype, "langId", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $ecf85bc592ac223d$var$TableSet.prototype, "languageName", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $ecf85bc592ac223d$var$TableSet.prototype, "languageSample", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $ecf85bc592ac223d$var$TableSet.prototype, "highlightString", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $ecf85bc592ac223d$var$TableSet.prototype, "shouldHighlightWord", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $ecf85bc592ac223d$var$TableSet.prototype, "highlightedSample", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $ecf85bc592ac223d$var$TableSet.prototype, "tableSize", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $ecf85bc592ac223d$var$TableSet.prototype, "relationTableSize", void 0);
$ecf85bc592ac223d$var$TableSet = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)('table-set')
], $ecf85bc592ac223d$var$TableSet);
var $ecf85bc592ac223d$export$2e2bcd8739ae039 = $ecf85bc592ac223d$var$TableSet;







const $13bc78ca8c6ca548$export$e938d6f191645a3e = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
  table {
    /*=====
        #Text #Size
    =====*/
    --tableBiggestTextSize: var(--biggerTextSize, 1.2em);
    --tableBiggerTextSize: var(--bigTextSize, 1.1em);
    --tableBaseTextSize: var(--smallTextSize, 0.8em);
    --tableSmallerTextSize: var(--smallerTextSize, 0.75em);
    --tableSmallestTextSize: var(--smallerTextSize, 0.618em);

    /* Variable to be used in td, th*/
    --tableCellSize: var(--tableBaseTextSize);

    /*=====
        #Title #Size
    =====*/
    --tableBiggestTitleSize: var(--baseTitleSize, 1.5em);
    --tableBiggerTitleSize: var(--biggestTextSize, 1.3em);
    --tableBaseTitleSize: var(--tableBiggestTextSize);
    --tableSmallerTitleSize: var(--tableBiggerTextSize);
    --tableSmallestTitleSize: var(--tableBaseTextSize);

    /* assume for any column headers*/
    --tableColHeaderSize: var(--tableBiggestTitleSize);
    /* assume for any row headers*/
    --tableRowHeaderSize: var(--tableBaseTitleSize);
    /*used by th in the tbody, thead, tfoot*/
    --tableHeaderSize: var(--tableRowHeaderSize);

    /*===== 
        #LineHeight 
    =====*/
    --tableBaseLineHeight: var(--smallLineHeight, 1.2);
    --tableSmallLineHeight: 1;

    /*===== 
        #Font #FontFamilies #Typeface
    =====*/
    --tableBaseFontFamily: var(
      --baseFontFamily,
      "Georgia",
      "Times New Roman",
      "serif"
    );
    --tableTitleFontFamily: var(
      --titleFontFamily,
      "Helvetica",
      "Arial",
      "sans-serif"
    );

    --tableCaptionTransform: capitalize;
    --tableCaptionFontStyle: italic;

    /*===== 
        #Border
    =====*/
    --tableBorderCollapse: collapse;
    --tableBorderColor: var(--baseInlineBorderColor, rgb(192.5, 192.5, 192.5));
    --tableBorderStyle: solid;

    --tableCellBorderWidth: 2px;
    --tableHeaderBorderWidth: var(--tableCellBorderWidth);

    /*===== 
        #Spacing
    =====*/
    --tableCellVertPadding: 0.4em;
    --tableCellHorzPadding: 0.618em;
    --tableTextAlign: left;
    --tableVertAlign: middle;

    /*=====
        #Colors
    =====*/
    --tableBaseTextColor: var(--baseTextColor, rgb(55, 55, 55));

    /*===== 
        #Background
    =====*/
    --tableBodyPrimaryBgColor: transparent;
    --tableBodyAlternatingBgColor: rgba(165, 165, 165, 0.3);

    --tablePrimaryBgColor: var(--tableBodyPrimaryBgColor);
    --tableAlternatingBgColor: var(--tableBodyAlternatingBgColor);
  }

  thead,
  tfoot,
  tbody {
    --borderWidth: var(--tableCellBorderWidth);
  }

  /* Not Necessary, but in case we want the header rows to be different from the body rows*/
  thead,
  tfoot {
    --tablePrimaryBgColor: var(--tableBodyAlternatingBgColor);
    --tableAlternatingBgColor: var(--tableBodyPrimaryBgColor);
  }

  /* thead will have bigger th and td*/
  thead {
    --tableHeaderSize: var(--tableColHeaderSize);
    --tableCellSize: var(--tableBiggerTextSize);
  }

  /* tfoot will have smaller th and td*/
  tfoot {
    --tableHeaderSize: var(--tableSmallestTitleSize);
    --tableCellSize: var(--tableSmallerTextSize);
  }

  /* tbody is the standard*/
  tbody {
    --tableHeaderSize: var(--tableRowHeaderSize);
    --tableCellSize: var(--tableCellSize);
  }

  /*=====
#Table    
=====*/
  table {
    border-collapse: var(--tableBorderCollapse);
    color: var(--tableBaseTextColor);
    font-family: var(--tableBaseFontFamily);
  }

  caption {
    font-size: var(--tableSmallestTextSize);
    text-transform: var(--tableCaptionTransform);
    font-style: var(--tableCaptionFontStyle);
  }

  /*=====
#Table #Cells   
=====*/
  th,
  td {
    text-align: var(--tableTextAlign);
    vertical-align: var(--tableVertAlign);
    line-height: var(--tableBaseLineHeight);
    padding: var(--tableCellVertPadding);
    border-color: var(--tableBorderColor);
    border-style: var(--tableBorderStyle);
  }

  th:empty,
  td:empty {
    padding: 0;
    border-width: 0;
  }

  td {
    font-size: var(--tableCellSize);
    border-width: var(--borderWidth);
  }

  th {
    font-family: var(--tableTitleFontFamily);
    font-weight: bold;
    font-size: var(--tableHeaderSize);
    border-width: var(--tableHeaderBorderWidth);
  }

  th[scope="rowgroup"] {
    font-size: var(--tableBiggestTitleSize);
    border-width: 0;
    padding: var(--tableCellVertPadding);
  }

  thead tr:nth-child(n + 2) th {
    font-size: var(--tableBiggerTitleSize);
  }

  thead tr:nth-child(n + 3) th {
    font-size: var(--tableBaseTitleSize);
  }

  thead th {
    border-bottom-width: var(--borderWidth);
  }

  tfoot th {
    border-top-width: var(--borderWidth);
  }

  /*=====
#Table #Rows
=====*/
  tr {
    background-color: var(--tablePrimaryBgColor);
  }

  tr:nth-child(even) {
    background-color: var(--tableAlternatingBgColor);
  }

  tr :first-child:empty,
  tr :last-child:empty {
    background-color: white;
  }

  colgroup:first-of-type:last-of-type ~ tbody tr :nth-child(even) {
    background-color: rgba(165, 165, 165, 0.2);
  }
`;


class $a16e9811470caf8f$var$FrequencyTable extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static{
        this.styles = [
            (0, $13bc78ca8c6ca548$export$e938d6f191645a3e),
            (0, $3233927aa82734f9$export$dbf350e5966cf602)`
    :host {
        flex-basis: 20vw;
        flex-grow: 1;
    }

    table {
        width: 100%;
    }
   
    th {
        --tableHeaderSize: var(--smallTextSize);
      }
    td {
        --tableCellSize: var(--smallerTextSize);
    }
    dl {
        display: inline-flex;
        flex-wrap: wrap;
        margin: 0;

    }
    dt {
        flex-basis: 50%;
    }

    `
        ];
    }
    getFrequency(frequency) {
        if (typeof frequency === 'number' || typeof frequency === 'string') return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`${frequency}`;
        if (frequency instanceof Map) {
            const entries = [
                ...frequency.entries()
            ];
            return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                <dl>
                    ${(0, $e41d1b66de65ecc4$export$76d90c956114f2c2)(entries, ([key, value])=>key, ([key, value])=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                        <dt>${key}: </dt>
                        <dd>${value}</dd>
                    `)}
                </dl>
            `;
        }
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <table class="table">
                <caption class="table__caption">${this.caption}</caption>
                <thead class="table__head">
                    <tr>
                        <th id="col1">${this.col1Header}</th>
                        <th id="col2">${this.col2Header}</th>
                    </tr>
                </thead>
                <tbody class="table__body">
                    ${(0, $e41d1b66de65ecc4$export$76d90c956114f2c2)(this.frequencies, (ngram)=>ngram.id, ([ngram, frequency])=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                        <tr>
                        <th headers="col1" id=${ngram} class="table__col1" title="click to highlight '${ngram}' in the text" lang="${this.langId}" direction="${this.direction}">${ngram}</th>
                        <td headers="${ngram} col2" class="table__col2">${this.getFrequency(frequency)}</td>
                        </tr>
                    `)}
                </tbody>
            </table>
        `;
    }
    constructor(...args){
        super(...args), this.caption = '', this.frequencies = new Map(), this.col1Header = 'N-gram', this.col2Header = 'Frequency', this.langId = '', this.direction = 'ltr';
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $a16e9811470caf8f$var$FrequencyTable.prototype, "caption", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: false
    })
], $a16e9811470caf8f$var$FrequencyTable.prototype, "frequencies", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $a16e9811470caf8f$var$FrequencyTable.prototype, "col1Header", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $a16e9811470caf8f$var$FrequencyTable.prototype, "col2Header", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $a16e9811470caf8f$var$FrequencyTable.prototype, "langId", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $a16e9811470caf8f$var$FrequencyTable.prototype, "direction", void 0);
$a16e9811470caf8f$var$FrequencyTable = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)('frequency-table')
], $a16e9811470caf8f$var$FrequencyTable);
var $a16e9811470caf8f$export$2e2bcd8739ae039 = $a16e9811470caf8f$var$FrequencyTable;




var $f2ac74c63282ab9d$require$LanguageNav = $11d2a92009e7857e$export$2e2bcd8739ae039;
var $f2ac74c63282ab9d$require$TableSet = $ecf85bc592ac223d$export$2e2bcd8739ae039;
var $f2ac74c63282ab9d$require$FrequencyTable = $a16e9811470caf8f$export$2e2bcd8739ae039;
// convert that map to ngram objects
// const ngrams = generateNgramsFromSamples(sampleMap, NGrammer);
// add it to the page
// makeTableSets(ngrams, document.querySelector('.js-tables'));
// makeNav(ngrams, document.querySelector('.js-nav'));
window.Methodius = $f2ac74c63282ab9d$require$Methodius;


//# sourceMappingURL=methodius-demo.d5452944.js.map
